(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[453,2306],{

/***/ 36902:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useFullscreenStatus; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* eslint-disable @typescript-eslint/no-unsafe-member-access */ 
function useFullscreenStatus() {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false), isFullscreen = ref[0], setIsFullscreen = ref[1];
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        document.onfullscreenchange = function() {
            var element = getBrowserFullscreenElementProp();
            if (element) {
                setIsFullscreen(document[element] != null);
            }
        };
        return function() {
            return document.onfullscreenchange = undefined;
        };
    });
    return [
        isFullscreen
    ];
};
var getBrowserFullscreenElementProp = function() {
    if (typeof document.fullscreenElement !== "undefined") {
        return "fullscreenElement";
    } else if (typeof document.mozFullScreenElement !== "undefined") {
        return "mozFullScreenElement";
    } else if (typeof document.msFullscreenElement !== "undefined") {
        return "msFullscreenElement";
    } else if (typeof document.webkitFullscreenElement !== "undefined") {
        return "webkitFullscreenElement";
    } else {
        return null;
    }
};


/***/ }),

/***/ 4858:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "uo": function() { return /* binding */ MediaLiveStreamCreator; },
  "ZP": function() { return /* binding */ components_MediaContent; }
});

// UNUSED EXPORTS: MediaLiveStream

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./common/interfaces/api.ts
var api = __webpack_require__(21694);
// EXTERNAL MODULE: ./common/utils/index.ts + 1 modules
var utils = __webpack_require__(22467);
// EXTERNAL MODULE: ./store/timeline.ts
var timeline = __webpack_require__(12800);
// EXTERNAL MODULE: ./node_modules/react-reverse-portal/dist/web/index.js
var web = __webpack_require__(12464);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/@rooks/use-fullscreen/lib/index.esm.js + 1 modules
var index_esm = __webpack_require__(94850);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-player/lazy/index.js
var lazy = __webpack_require__(56310);
var lazy_default = /*#__PURE__*/__webpack_require__.n(lazy);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(93967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Slider/Slider.js + 1 modules
var Slider = __webpack_require__(59122);
// EXTERNAL MODULE: ./components/common/Icon/index.tsx
var Icon = __webpack_require__(37975);
// EXTERNAL MODULE: ./components/common/VideoPlayer/VideoPlayer.module.scss
var VideoPlayer_module = __webpack_require__(19951);
var VideoPlayer_module_default = /*#__PURE__*/__webpack_require__.n(VideoPlayer_module);
// EXTERNAL MODULE: ./store/global.ts
var global = __webpack_require__(8405);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./components/common/PlayerRateOptions/index.tsx
var PlayerRateOptions = __webpack_require__(64739);
// EXTERNAL MODULE: ./components/common/Button/index.tsx
var Button = __webpack_require__(98133);
// EXTERNAL MODULE: ./common/utils/fullscreen.ts
var fullscreen = __webpack_require__(36902);
// EXTERNAL MODULE: ./common/utils/membership.ts
var membership = __webpack_require__(77063);
// EXTERNAL MODULE: ./common/utils/pp_tracking.ts
var pp_tracking = __webpack_require__(67027);
// EXTERNAL MODULE: ./common/utils/post.ts
var post = __webpack_require__(40783);
// EXTERNAL MODULE: ./node_modules/zustand/esm/index.js
var esm = __webpack_require__(14671);
;// CONCATENATED MODULE: ./store/watch_time_tracking.ts



var useWatchTimeTracking = (0,esm/* default */.Z)(function(set, get) {
    return {
        // states
        watchedMedias: {},
        increaseWatchTimeOfMedia: function(id) {
            var watchedMedias = get().watchedMedias;
            if ((0,utils/* isNumber */.hj)(watchedMedias[id.toString()])) {
                watchedMedias[id.toString()] = watchedMedias[id.toString()] + 1;
            } else {
                watchedMedias[id.toString()] = 1;
            }
            set({
                watchedMedias: watchedMedias
            });
        },
        stopWatchingMedia: function(id) {
            var watchedMedias = get().watchedMedias;
            if ((0,utils/* isNumber */.hj)(watchedMedias[id.toString()])) {
                (0,post/* addWatchTimeEvent */.AX)({
                    postId: id,
                    watchTime: watchedMedias[id.toString()]
                });
                delete watchedMedias[id.toString()];
                set({
                    watchedMedias: watchedMedias
                });
            }
        }
    };
});
/* harmony default export */ var watch_time_tracking = (useWatchTimeTracking);

// EXTERNAL MODULE: ./service/media.ts
var media = __webpack_require__(94895);
// EXTERNAL MODULE: ./node_modules/@amplitude/analytics-browser/lib/esm/index.js + 164 modules
var lib_esm = __webpack_require__(38367);
;// CONCATENATED MODULE: ./components/common/VideoPlayer/index.tsx




























var AutoplayThreshold;
(function(AutoplayThreshold) {
    AutoplayThreshold[AutoplayThreshold["Center"] = 0] = "Center";
    AutoplayThreshold[AutoplayThreshold["Top"] = 1] = "Top";
})(AutoplayThreshold || (AutoplayThreshold = {}));
function VideoPlayer(param) {
    var id = param.id, url = param.url, thumbnail = param.thumbnail, postAuthor = param.postAuthor, _autoplayThreshold = param.autoplayThreshold, autoplayThreshold = _autoplayThreshold === void 0 ? AutoplayThreshold.Center : _autoplayThreshold, _autoplayOnMount = param.autoplayOnMount, autoplayOnMount = _autoplayOnMount === void 0 ? false : _autoplayOnMount, _isLocked = param.isLocked, isLocked = _isLocked === void 0 ? false : _isLocked, _disableAutoPlayOnFocus = param.disableAutoPlayOnFocus, disableAutoPlayOnFocus = _disableAutoPlayOnFocus === void 0 ? false : _disableAutoPlayOnFocus, _isPostDetail = param.isPostDetail, isPostDetail = _isPostDetail === void 0 ? false : _isPostDetail, postType = param.postType, _canSeeFreeMinutes = param.canSeeFreeMinutes, canSeeFreeMinutes = _canSeeFreeMinutes === void 0 ? false : _canSeeFreeMinutes, _freeMinutes = param.freeMinutes, freeMinutes = _freeMinutes === void 0 ? 0 : _freeMinutes, freeUrl = param.freeUrl, fullDuration = param.fullDuration, parent = param.parent, postSource = param.postSource;
    var ref = (0,_sliced_to_array/* default */.Z)((0,timeline/* default */.ZP)(function(state) {
        return [
            state.activeAudioPlayer,
            state.setActiveAudioPlayer, 
        ];
    }), 2), activeAudioPlayer = ref[0], setActiveAudioPlayer = ref[1];
    var bottomBarRef = (0,react.useRef)(null);
    var mediaControlRef = (0,react.useRef)(null);
    var setSnackbarMessage = (0,global/* default */.Z)(function(state) {
        return state.setSnackbarMessage;
    });
    var ref1 = (0,react.useState)(false), isMounted = ref1[0], setIsMounted = ref1[1];
    var router = (0,next_router.useRouter)();
    var showPaymentDialog = (0,global/* default */.Z)(function(state) {
        return state.showPaymentDialog;
    });
    var currentUser = (0,timeline/* default */.ZP)(function(state) {
        return state.currentUser;
    });
    var setShowMembershipPayDialog = (0,global/* default */.Z)(function(state) {
        return state.setShowMembershipPayDialog;
    });
    var increaseWatchTimeOfMedia = watch_time_tracking(function(state) {
        return state.increaseWatchTimeOfMedia;
    });
    var stopWatchingMedia = watch_time_tracking(function(state) {
        return state.stopWatchingMedia;
    });
    var ref2 = (0,index_esm/* default */.Z)(), toggleFullscreen = ref2.toggle, isFullscreen = ref2.isFullscreen;
    var playerRef = (0,react.useRef)(null);
    var playerWrapperRef = (0,react.useRef)(null);
    var ref3 = (0,react.useState)(true), muted = ref3[0], setMuted = ref3[1];
    var ref4 = (0,react.useState)(1), volume = ref4[0], setVolume = ref4[1];
    var ref5 = (0,react.useState)(0), timebarVal = ref5[0], setTimebarVal = ref5[1];
    var ref6 = (0,react.useState)(autoplayOnMount && !isLocked), playing = ref6[0], setPlaying = ref6[1];
    var ref7 = (0,react.useState)(0), playedSeconds = ref7[0], setPlayedSeconds = ref7[1];
    var ref8 = (0,react.useState)(0), duration = ref8[0], setDuration = ref8[1];
    var ref9 = (0,react.useState)(1), playbackRate = ref9[0], setPlaybackRate = ref9[1];
    var ref10 = (0,react.useState)(false), hasEnded = ref10[0], setHasEnded = ref10[1];
    var isMobileScreen = (0,utils/* useMediaQuery */.ac)("(max-width: 767px)");
    var isCenter = autoplayThreshold === AutoplayThreshold.Center;
    var ref11 = (0,react.useState)(false), isHover = ref11[0], setIsHover = ref11[1];
    var ref12 = (0,react.useState)(-1), lastClickTime = ref12[0], setLastClickTime = ref12[1];
    var freeTimesRef = (0,react.useRef)(null);
    var ref13 = (0,react.useState)(0), remainingFreeSeconds = ref13[0], setRemainingFreeSeconds = ref13[1];
    var ref14 = (0,react.useState)(0), playedFreeTimes = ref14[0], setPlayedFreeTimes = ref14[1];
    var ref15 = (0,_sliced_to_array/* default */.Z)((0,fullscreen/* default */.Z)(), 1), isFullScreenBrowser = ref15[0];
    var ref16 = (0,react.useState)(false), isReady = ref16[0], setIsReady = ref16[1];
    // Stop playing audio when other audio sources starts playing
    // Note: how is this working?? why don't playing and muted become stale values??
    (0,react.useEffect)(function() {
        if ((activeAudioPlayer === null || activeAudioPlayer === void 0 ? void 0 : activeAudioPlayer.playing) && playing && !muted) {
            setMuted(true);
        }
    }, [
        activeAudioPlayer,
        playing,
        muted
    ]);
    var onStart = (0,react.useCallback)(function() {
        if (!playerRef.current) return;
        if (!isLocked && playedFreeTimes > 0) {
            playerRef.current.seekTo(playedFreeTimes);
            setPlayedFreeTimes(0);
        }
    }, [
        isLocked,
        playedFreeTimes
    ]);
    (0,react.useEffect)(function() {
        setPlayedFreeTimes(0);
        setPlayedSeconds(0);
        setPlaying(autoplayOnMount && !isLocked);
        return function() {
            if (isPostDetail) {
                stopWatchingMedia(id);
            }
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        id
    ]);
    (0,react.useEffect)(function() {
        setIsMounted(true);
    }, []);
    (0,react.useEffect)(function() {
        if (!isPostDetail) return;
        if (!canSeeFreeMinutes || freeMinutes === 0 || !showPaymentDialog) {
            setRemainingFreeSeconds(0);
            return;
        }
        var rmFreeSecs = Math.round(Math.max(0, Math.min(freeMinutes * 60, duration) - playedSeconds));
        setRemainingFreeSeconds(rmFreeSecs);
        if (rmFreeSecs === 1) {
            setPlayedFreeTimes(0);
            if (playerRef.current) {
                playerRef.current.seekTo(0);
            }
            setTimeout(function() {
                setPlaying(false);
            }, 1000);
            showPaymentDialog({
                creator: postAuthor
            });
        }
    }, [
        canSeeFreeMinutes,
        duration,
        freeMinutes,
        playedSeconds,
        postAuthor,
        showPaymentDialog,
        isPostDetail, 
    ]);
    // Autoplay
    var intersectionCb = (0,react.useCallback)(function(entries) {
        var aTimeout, bTImeout;
        if (disableAutoPlayOnFocus) return;
        var target = entries[0];
        if (target && target.isIntersecting) {
            // CENTER: entering the middle 10% of screen height
            // TOP: over 30% of video is shown and user has not intentionally paused the video
            if (!isLocked) {
                aTimeout = setTimeout(function() {
                    var ref;
                    var light = (ref = playerWrapperRef.current) === null || ref === void 0 ? void 0 : ref.querySelector(".react-player__preview");
                    if (light) {
                        light.click();
                    }
                }, 500);
                bTImeout = setTimeout(function() {
                    setPlaying(true);
                }, 2000);
            }
        } else {
            // CENTER: leaving the middle 10% of screen height
            // TOP: under 30% of video is shown
            setPlaying(false);
            if (playerRef.current) {
                // This is the key to keeping the player in light mode
                playerRef.current.showPreview();
            }
        }
        return function() {
            aTimeout && clearTimeout(aTimeout);
            bTImeout && clearTimeout(bTImeout);
        };
    }, [
        disableAutoPlayOnFocus,
        isLocked
    ]);
    (0,react.useEffect)(function() {
        if (isLocked || isFullscreen || !isMounted) return;
        var ref = playerWrapperRef.current;
        var options = {
            root: null,
            rootMargin: isCenter ? "-45% 0px -45%" : "0px",
            threshold: isCenter ? 0 : 0.3
        };
        // Create observer
        var observer = new IntersectionObserver(intersectionCb, options);
        // observe the audio player
        if (ref) {
            observer.observe(ref);
        }
        // clean up on willUnMount
        return function() {
            if (ref) {
                observer.unobserve(ref);
            }
        };
    // Note: for some reason playerWrapperRef.current needs to be in the dependency array
    // otherwise initial target.isIntersecting will always be false
    }, [
        isCenter,
        intersectionCb,
        isLocked,
        playerWrapperRef,
        isFullscreen,
        isMounted, 
    ]);
    // Rewind and fast forward with
    // - positive skipTime means fast forward
    // - negative skipTime means rewind
    var handleTimeSkip = (0,react.useCallback)(function(skipTime) {
        if (isLocked) return;
        if (!playerRef.current) return;
        if (skipTime < 0) {
            (0,utils/* increaseViewCount */.wh)(id);
        }
        var newTime = playedSeconds + skipTime;
        if (newTime > duration) newTime = duration - 1;
        if (newTime < 0) newTime = 0;
        setPlayedSeconds(newTime);
        playerRef.current.seekTo(newTime, "seconds");
        setTimeout(function() {
            if (newTime === duration) {
                setHasEnded(true);
            }
        }, 500);
    }, [
        duration,
        id,
        isLocked,
        playedSeconds
    ]);
    // Media control overlay
    var mediaControlBtn = (0,react.useMemo)(function() {
        var btn;
        if (hasEnded) {
            btn = /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (VideoPlayer_module_default()).replayWrapper,
                onClick: function() {
                    return setPlaying(true);
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.ZP, {
                        name: "replay",
                        width: 96,
                        height: 96
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (VideoPlayer_module_default()).replayText,
                        children: "最初から見る"
                    })
                ]
            });
        } else if (!playing) {
            btn = /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (VideoPlayer_module_default()).playWrapper,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (VideoPlayer_module_default()).skipBtn,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.ZP, {
                            name: "play-rewind",
                            height: 50,
                            width: 50,
                            onClick: function() {
                                return handleTimeSkip(-15);
                            }
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (VideoPlayer_module_default()).centerBtn,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.ZP, {
                            name: "play",
                            width: 96,
                            height: 96,
                            onClick: function() {
                                return setPlaying(true);
                            }
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (VideoPlayer_module_default()).skipBtn,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.ZP, {
                            name: "play-forward",
                            height: 50,
                            width: 50,
                            onClick: function() {
                                return handleTimeSkip(15);
                            }
                        })
                    })
                ]
            });
        } else if (!isFullscreen && playing) {
            btn = /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: classnames_default()((VideoPlayer_module_default()).playWrapper, (VideoPlayer_module_default()).pauseBtn),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (VideoPlayer_module_default()).skipBtn,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.ZP, {
                            name: "play-rewind",
                            height: 50,
                            width: 50,
                            onClick: function() {
                                return handleTimeSkip(-15);
                            }
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (VideoPlayer_module_default()).centerBtn,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.ZP, {
                            name: "pause",
                            width: 96,
                            height: 96,
                            onClick: function() {
                                return setPlaying(false);
                            }
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (VideoPlayer_module_default()).skipBtn,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.ZP, {
                            name: "play-forward",
                            height: 50,
                            width: 50,
                            onClick: function() {
                                return handleTimeSkip(15);
                            }
                        })
                    })
                ]
            });
        }
        return btn;
    }, [
        handleTimeSkip,
        hasEnded,
        isFullscreen,
        playing
    ]);
    var handleSpeakerBtnClick = (0,react.useCallback)(function(e) {
        e.stopPropagation();
        setMuted(function(muted) {
            return !muted;
        });
        if (playing && muted) {
            setActiveAudioPlayer("video", false);
            (0,lib_esm/* track */.j)("Turn On Video Volume");
        }
    }, [
        muted,
        playing,
        setActiveAudioPlayer
    ]);
    // Volume
    var handleVolumeChange = (0,react.useCallback)(function(e, newVolume) {
        e.stopPropagation();
        if (isLocked) return;
        if (!(0,utils/* isNumber */.hj)(newVolume) || Array.isArray(newVolume)) {
            newVolume = 0.5;
        }
        if (newVolume < 0.025) {
            setMuted(true);
        } else {
            setMuted(false);
            setVolume(newVolume);
            if (playing) {
                setActiveAudioPlayer("video", false);
            }
        }
    }, [
        isLocked,
        playing,
        setActiveAudioPlayer
    ]);
    // Timebar
    var handleTimebarChange = (0,react.useCallback)(function(e) {
        e.stopPropagation();
        if (isLocked) return;
        if (!playerRef.current) return;
        var newTimebarVal = Number(e.target.value);
        playerRef.current.seekTo(newTimebarVal, "fraction");
        // support seek for only case watch full version => do need use fullDuration
        setPlayedSeconds(newTimebarVal * duration);
        setTimebarVal(newTimebarVal);
        setTimeout(function() {
            if (newTimebarVal === 1) {
                setHasEnded(true);
            }
        }, 500);
    }, [
        duration,
        isLocked
    ]);
    (0,react.useEffect)(function() {
        if (lastClickTime > 0) return;
        setTimebarVal(duration === 0 ? 0 : playedSeconds / duration);
    }, [
        playedSeconds,
        setTimebarVal,
        duration,
        lastClickTime
    ]);
    var handleClickFullscreen = function(e) {
        var ref, ref1;
        e.stopPropagation();
        if (isLocked) return;
        (0,lib_esm/* track */.j)("See Full Screen");
        try {
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            if (document.exitFullscreen && document.mozFullScreen) {
                void document.exitFullscreen();
            }
        // eslint-disable-next-line no-empty
        } catch (error) {}
        if (!isMobileScreen) {
            void toggleFullscreen(playerWrapperRef.current);
            return;
        }
        /* eslint-disable @typescript-eslint/ban-ts-comment */ // @ts-ignore
        var elem = (ref1 = (ref = playerRef.current) === null || ref === void 0 ? void 0 : ref.wrapper) === null || ref1 === void 0 ? void 0 : ref1.querySelector("video");
        // @ts-ignore
        if (elem && elem.webkitEnterFullScreen) {
            // @ts-ignore
            // eslint-disable-next-line @typescript-eslint/no-unsafe-call
            elem.webkitEnterFullScreen();
        } else void toggleFullscreen(playerWrapperRef.current);
    /* eslint-enable @typescript-eslint/ban-ts-comment */ };
    var stopPropagation = function(e) {
        e.stopPropagation();
    };
    var handleOverlayClick = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(e) {
            var ref, ref1, ref2, selection;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        stopPropagation(e);
                        if (isPostDetail) {
                            _ctx.next = 6;
                            break;
                        }
                        (0,post/* addClickPostEvent */.lR)({
                            postId: id,
                            screen: (0,pp_tracking/* parentKeyToScreenName */.lF)(parent),
                            postSource: postSource,
                            clickPosition: "media_view",
                            postType: postType,
                            mediaType: media/* MediaType.Video */.D.Video
                        });
                        _ctx.next = 5;
                        return router.push("/".concat(postAuthor.username, "/posts/").concat(id));
                    case 5:
                        return _ctx.abrupt("return");
                    case 6:
                        if (!isLocked) {
                            _ctx.next = 10;
                            break;
                        }
                        {
                            handleTrialClick();
                        }
                        _ctx.next = 15;
                        break;
                    case 10:
                        ;
                        if (!(freeTimesRef === null || freeTimesRef === void 0 ? void 0 : (ref = freeTimesRef.current) === null || ref === void 0 ? void 0 : ref.contains(e.target))) {
                            _ctx.next = 13;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 13:
                        selection = window.getSelection();
                        if (selection.type != "Range" && !(bottomBarRef === null || bottomBarRef === void 0 ? void 0 : (ref1 = bottomBarRef.current) === null || ref1 === void 0 ? void 0 : ref1.contains(e.target)) && !(mediaControlRef === null || mediaControlRef === void 0 ? void 0 : (ref2 = mediaControlRef.current) === null || ref2 === void 0 ? void 0 : ref2.contains(e.target))) {
                            setPlaying(function(playing) {
                                return !playing;
                            });
                            if (!playing) {
                                setActiveAudioPlayer("video", false);
                                (0,utils/* increaseViewCount */.wh)(id);
                            }
                        }
                    case 15:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleOverlayClick(e) {
            return _ref.apply(this, arguments);
        };
    }();
    var hms = (0,react.useMemo)(function() {
        return duration > 0 && duration >= playedSeconds ? (0,utils/* secondsToHms */.qt)(playedSeconds) : utils/* DEFAULT_TIME_HMS */.pr;
    }, [
        duration,
        playedSeconds
    ]);
    var totalHms = (0,react.useMemo)(function() {
        return (0,utils/* secondsToHms */.qt)(canSeeFreeMinutes ? fullDuration : duration);
    }, [
        canSeeFreeMinutes,
        duration,
        fullDuration
    ]);
    var reactPlayerStyle = (0,react.useMemo)(function() {
        var style;
        if (isFullscreen || isFullScreenBrowser) {
            style = {
                position: "absolute",
                top: 0,
                bottom: 0,
                left: 0,
                right: 0
            };
        } else {
            style = {};
        }
        return style;
    }, [
        isFullScreenBrowser,
        isFullscreen
    ]);
    var handleTrialClick = function() {
        if (postType === api/* PostType.Gold */.hQ.Gold && !(0,membership/* isGoldMember */.Ic)(currentUser)) {
            setShowMembershipPayDialog({
                open: true,
                showMembershipStatus: false,
                initPackage: api/* MembershipPackageName.Platinum */.uh.Platinum,
                screen: pp_tracking/* ScreenName.PostDetail */.CG.PostDetail
            });
            return;
        }
        if (!postAuthor) return;
        // in case of value is undefined, still can open payment dialog
        if (postAuthor.is_open_for_subscription === false && (0,post/* checkIsCreatorPaidPost */.b8)(postType)) {
            setSnackbarMessage({
                type: "error",
                text: (0,post/* exCreatorPostLockMessage */.e8)(postType)
            });
            return;
        }
        showPaymentDialog({
            creator: postAuthor
        });
    };
    (0,react.useEffect)(function() {
        if (isMobileScreen && !isLocked) return;
        if (isHover && !isLocked) {
            var ref;
            var light = (ref = playerWrapperRef.current) === null || ref === void 0 ? void 0 : ref.querySelector(".react-player__preview");
            if (light) {
                light.click();
            }
        }
    }, [
        isHover,
        isLocked,
        isMobileScreen
    ]);
    (0,react.useEffect)(function() {
        if (isMobileScreen && !isLocked) return;
        var timeOut = setTimeout(function() {
            var img = new Image();
            img.onload = function() {
                if (!playerWrapperRef.current) return;
                var light = playerWrapperRef.current.querySelector(".react-player__preview");
                var wrapperWidth = playerWrapperRef.current.clientWidth;
                if (light) {
                    light.style.minHeight = "".concat(wrapperWidth / img.width * img.height, "px");
                }
            };
            img.src = thumbnail;
        }, 600);
        return function() {
            return clearTimeout(timeOut);
        };
    }, [
        thumbnail,
        isMobileScreen,
        isLocked
    ]);
    var seekPercent = Math.min(Math.ceil(timebarVal * 100), 100);
    var _obj, _obj1;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: classnames_default()((VideoPlayer_module_default()).playerWrapper, (_obj = {}, (0,_define_property/* default */.Z)(_obj, (VideoPlayer_module_default()).isPostDetail, isPostDetail), (0,_define_property/* default */.Z)(_obj, (VideoPlayer_module_default()).fullscreenVideo, isFullscreen || isFullScreenBrowser), _obj)),
        ref: playerWrapperRef,
        onMouseLeave: function() {
            return setIsHover(false);
        },
        onMouseEnter: function() {
            return setIsHover(true);
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)((lazy_default()), {
                width: "100%",
                height: "100%",
                style: reactPlayerStyle,
                ref: playerRef,
                url: canSeeFreeMinutes && freeUrl ? freeUrl : url,
                muted: !isPostDetail || muted,
                volume: volume,
                playsinline: true,
                playing: playing && isReady && isMounted,
                playbackRate: playbackRate,
                onError: function() {
                    if (!isReady) return;
                    setTimeout(function() {
                        if (playerRef.current && playedSeconds < 10) {
                            playerRef.current.seekTo(playedSeconds + 2);
                        }
                    }, 500);
                },
                onReady: function() {
                    setIsReady(true);
                    if (isPostDetail) {
                        (0,lib_esm/* track */.j)("Start Play Video In PostDetail");
                    }
                },
                onProgress: function(param) {
                    var playedSeconds = param.playedSeconds;
                    if (isPostDetail) {
                        increaseWatchTimeOfMedia(id);
                    }
                    setPlayedSeconds(playedSeconds);
                    if (playedSeconds < duration - 1 && hasEnded) {
                        setHasEnded(false);
                    }
                    if (canSeeFreeMinutes) {
                        setPlayedFreeTimes(playedSeconds);
                    }
                },
                onDuration: function(duration) {
                    return setDuration(duration);
                },
                onPlay: function() {
                    setHasEnded(false);
                },
                onEnded: function() {
                    setHasEnded(true);
                    setPlaying(false);
                },
                onStart: onStart,
                light: (isMobileScreen || disableAutoPlayOnFocus) && !isLocked ? false : thumbnail,
                config: {
                    file: {
                        attributes: {
                            poster: thumbnail
                        }
                    }
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: classnames_default()((VideoPlayer_module_default()).playerOverlay, (_obj1 = {}, (0,_define_property/* default */.Z)(_obj1, (VideoPlayer_module_default()).fullscreen, isFullscreen || isFullScreenBrowser), (0,_define_property/* default */.Z)(_obj1, (VideoPlayer_module_default()).notPostDetail, !isPostDetail), _obj1)),
                onClick: handleOverlayClick,
                children: [
                    canSeeFreeMinutes && isPostDetail && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (VideoPlayer_module_default()).remainingFreeTime,
                        ref: freeTimesRef,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: (VideoPlayer_module_default()).time,
                                        children: (0,utils/* secondsToHms */.qt)(Math.max(remainingFreeSeconds, 0))
                                    }),
                                    "残りの無料時間"
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                text: "プライム登録を無料体験",
                                onClick: function(e) {
                                    showPaymentDialog({
                                        creator: postAuthor
                                    });
                                    if (isFullscreen || isFullScreenBrowser) {
                                        handleClickFullscreen(e);
                                    }
                                }
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (VideoPlayer_module_default()).mediaControlBtn,
                        ref: mediaControlRef,
                        children: mediaControlBtn
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (VideoPlayer_module_default()).bottomBar,
                        ref: bottomBarRef,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (VideoPlayer_module_default()).timeBarSection,
                                children: !canSeeFreeMinutes && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (VideoPlayer_module_default()).timebar,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                        type: "range",
                                        min: 0,
                                        max: 1,
                                        step: 0.025,
                                        value: timebarVal,
                                        style: {
                                            background: "linear-gradient(to right, #FF2D55 0%, #FF2D55 ".concat(seekPercent, "%, #aeaeae ").concat(seekPercent, "%,rgb(145, 137, 137) 100%)")
                                        },
                                        onChange: handleTimebarChange,
                                        className: (VideoPlayer_module_default()).sliderTime,
                                        onMouseDown: function() {
                                            setLastClickTime(timebarVal);
                                        },
                                        onMouseUp: function() {
                                            // call event increase view count
                                            if (lastClickTime > timebarVal) {
                                                (0,utils/* increaseViewCount */.wh)(id);
                                            }
                                            setLastClickTime(-1);
                                        }
                                    }, "video-time-slider-".concat(id))
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (VideoPlayer_module_default()).controlButtons,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (VideoPlayer_module_default()).leftCorner,
                                        children: [
                                            duration > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: (VideoPlayer_module_default()).playTime,
                                                children: [
                                                    hms,
                                                    " / ",
                                                    totalHms
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: (VideoPlayer_module_default()).volumeCtrl,
                                                onClick: stopPropagation,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: (VideoPlayer_module_default()).speakerBtn,
                                                        onClick: handleSpeakerBtnClick,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.ZP, {
                                                            name: "speaker",
                                                            width: 26,
                                                            height: 26,
                                                            hasOn: true,
                                                            isOn: !muted
                                                        })
                                                    }),
                                                    !isMobileScreen && /*#__PURE__*/ (0,jsx_runtime.jsx)(Slider/* default */.Z, {
                                                        defaultValue: 1,
                                                        min: 0,
                                                        max: 1,
                                                        step: 0.025,
                                                        onChange: handleVolumeChange,
                                                        className: (VideoPlayer_module_default()).volumeSlider
                                                    }, "video-slider-".concat(id))
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (VideoPlayer_module_default()).rightCorner,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: (VideoPlayer_module_default()).speedCtrl,
                                                onClick: stopPropagation,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: (VideoPlayer_module_default()).speedCtrlOptions,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PlayerRateOptions/* default */.Z, {
                                                            setPlaybackRate: setPlaybackRate,
                                                            clickCallback: function() {
                                                                try {
                                                                    if (isFullscreen || isFullScreenBrowser) {
                                                                        if (document.exitFullscreen && // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
                                                                        (document).mozFullScreen) {
                                                                            void document.exitFullscreen();
                                                                            return;
                                                                        }
                                                                        void toggleFullscreen();
                                                                    }
                                                                // eslint-disable-next-line no-empty
                                                                } catch (error) {}
                                                            }
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: (VideoPlayer_module_default()).speedBtn,
                                                        children: [
                                                            playbackRate,
                                                            "x"
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: (VideoPlayer_module_default()).fullscreenBtn,
                                                onClick: handleClickFullscreen,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.ZP, {
                                                            name: "fullscreen",
                                                            width: 17,
                                                            height: 17
                                                        })
                                                    }),
                                                    !isMobileScreen && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: (VideoPlayer_module_default()).fullscreenText,
                                                        children: isFullscreen ? "全画面を閉じる" : "全画面で見る"
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};

// EXTERNAL MODULE: ./components/common/LiveStreamPlayer/LiveStreamPlayer.module.scss
var LiveStreamPlayer_module = __webpack_require__(83688);
var LiveStreamPlayer_module_default = /*#__PURE__*/__webpack_require__.n(LiveStreamPlayer_module);
// EXTERNAL MODULE: ./service/livestream.ts
var livestream = __webpack_require__(83588);
;// CONCATENATED MODULE: ./components/common/LiveStreamPlayer/index.tsx

























var LiveStreamPlayer_AutoplayThreshold;
(function(AutoplayThreshold) {
    AutoplayThreshold[AutoplayThreshold["Center"] = 0] = "Center";
    AutoplayThreshold[AutoplayThreshold["Top"] = 1] = "Top";
})(LiveStreamPlayer_AutoplayThreshold || (LiveStreamPlayer_AutoplayThreshold = {}));
function LiveStreamPlayer(param) {
    var id = param.id, url = param.url, streamId = param.streamId, _viewerCount = param.viewerCount, viewerCount = _viewerCount === void 0 ? 0 : _viewerCount, thumbnail = param.thumbnail, postAuthor = param.postAuthor, _autoplayOnMount = param.autoplayOnMount, autoplayOnMount = _autoplayOnMount === void 0 ? false : _autoplayOnMount, _isLocked = param.isLocked, isLocked = _isLocked === void 0 ? false : _isLocked, _isPostDetail = param.isPostDetail, isPostDetail = _isPostDetail === void 0 ? false : _isPostDetail, postType = param.postType, startedAt = param.startedAt, _isLiveStreamDetail = param.isLiveStreamDetail, isLiveStreamDetail = _isLiveStreamDetail === void 0 ? false : _isLiveStreamDetail, _isLive = param.isLive, isLive = _isLive === void 0 ? true : _isLive, _disableAutoPlayOnFocus = param.disableAutoPlayOnFocus, disableAutoPlayOnFocus = _disableAutoPlayOnFocus === void 0 ? false : _disableAutoPlayOnFocus, _canSeeFreeMinutes = param.canSeeFreeMinutes, canSeeFreeMinutes = _canSeeFreeMinutes === void 0 ? false : _canSeeFreeMinutes, _freeMinutes = param.freeMinutes, freeMinutes = _freeMinutes === void 0 ? 0 : _freeMinutes, handleStopFreeTimes = param.handleStopFreeTimes, startPosition = param.startPosition;
    var ref = (0,_sliced_to_array/* default */.Z)((0,timeline/* default */.ZP)(function(state) {
        return [
            state.activeAudioPlayer,
            state.setActiveAudioPlayer, 
        ];
    }), 2), activeAudioPlayer = ref[0], setActiveAudioPlayer = ref[1];
    var setSnackbarMessage = (0,global/* default */.Z)(function(state) {
        return state.setSnackbarMessage;
    });
    var freeTimesRef = (0,react.useRef)(null);
    var ref1 = (0,react.useState)(false), isMounted = ref1[0], setIsMounted = ref1[1];
    var currentAuth = (0,global/* default */.Z)(function(state) {
        return state.currentAuth;
    });
    var currentUser = (0,timeline/* default */.ZP)(function(state) {
        return state.currentUser;
    });
    var router = (0,next_router.useRouter)();
    var showLogin = (0,global/* default */.Z)(function(state) {
        return state.showLogin;
    });
    var showPaymentDialog = (0,global/* default */.Z)(function(state) {
        return state.showPaymentDialog;
    });
    var setShowMembershipPayDialog = (0,global/* default */.Z)(function(state) {
        return state.setShowMembershipPayDialog;
    });
    var bottomBarRef = (0,react.useRef)(null);
    var ref2 = (0,react.useState)(0), timebarVal = ref2[0], setTimebarVal = ref2[1];
    var ref3 = (0,react.useState)(false), isMouseDowningTimeBar = ref3[0], setIsMouseDowningTimeBar = ref3[1];
    var ref4 = (0,react.useState)(0), displayPlayedSeconds = ref4[0], setDisplayPlayedSeconds = ref4[1];
    var ref5 = (0,index_esm/* default */.Z)(), toggleFullscreen = ref5.toggle, isFullscreen = ref5.isFullscreen;
    var playerRef = (0,react.useRef)(null);
    var playerWrapperRef = (0,react.useRef)(null);
    var ref6 = (0,react.useState)(true), muted = ref6[0], setMuted = ref6[1];
    var ref7 = (0,react.useState)(1), volume = ref7[0], setVolume = ref7[1];
    var ref8 = (0,react.useState)(autoplayOnMount && !isLocked), playing = ref8[0], setPlaying = ref8[1];
    var isMobileScreen = (0,utils/* useMediaQuery */.ac)("(max-width: 767px)");
    var ref9 = (0,react.useState)((0,utils/* secondsToNow */.US)(new Date(startedAt))), displayDuration = ref9[0], setDisplayDuration = ref9[1];
    var ref10 = (0,react.useState)(false), isReady = ref10[0], setIsReady = ref10[1];
    var ref11 = (0,react.useState)(false), isHover = ref11[0], setIsHover = ref11[1];
    var deviceInfo = (0,utils/* useDevice */.Fy)();
    var ref12 = (0,react.useState)(0), remainingFreeSeconds = ref12[0], setRemainingFreeSeconds = ref12[1];
    var ref13 = (0,_sliced_to_array/* default */.Z)((0,fullscreen/* default */.Z)(), 1), isFullScreenBrowser = ref13[0];
    var ref14 = (0,react.useState)(false), isBuffering = ref14[0], setIsBuffering = ref14[1];
    var mediaControlRef = (0,react.useRef)(null);
    var realDuration = displayDuration + startPosition;
    var realPlayedSeconds = displayPlayedSeconds + startPosition;
    (0,react.useEffect)(function() {
        if (isMouseDowningTimeBar) return;
        if (displayDuration > 0) {
            setTimebarVal(Math.min(displayPlayedSeconds / displayDuration, 1));
        }
    }, [
        displayPlayedSeconds,
        displayDuration,
        isMouseDowningTimeBar
    ]);
    (0,react.useEffect)(function() {
        var interval = setInterval(function() {
            var ref;
            if (!(playerRef === null || playerRef === void 0 ? void 0 : playerRef.current)) return;
            var duration = playerRef === null || playerRef === void 0 ? void 0 : (ref = playerRef.current) === null || ref === void 0 ? void 0 : ref.getDuration();
            if (duration && duration - startPosition > 0) {
                setDisplayDuration(duration - startPosition);
            }
        }, 5000);
        return function() {
            return clearInterval(interval);
        };
    }, [
        startPosition
    ]);
    var handleTimebarChange = function(e) {
        var newValue = parseFloat(e.target.value);
        var newPosition = startPosition + newValue * displayDuration;
        if (playerRef.current) {
            playerRef.current.seekTo(newPosition);
            setTimebarVal(newValue);
            setDisplayPlayedSeconds(newPosition - startPosition);
        }
    };
    var handleProgress = function(state) {
        if (isMouseDowningTimeBar) return;
        var newPlayedSeconds = Math.max(0, state.playedSeconds - startPosition);
        setDisplayPlayedSeconds(newPlayedSeconds);
    };
    // Stop playing audio when other audio sources starts playing
    // Note: how is this working?? why don't playing and muted become stale values??
    (0,react.useEffect)(function() {
        if ((activeAudioPlayer === null || activeAudioPlayer === void 0 ? void 0 : activeAudioPlayer.playing) && playing && !muted) {
            setMuted(true);
        }
    }, [
        activeAudioPlayer,
        playing,
        muted
    ]);
    (0,react.useEffect)(function() {
        setIsMounted(true);
    }, []);
    (0,react.useEffect)(function() {
        if (!canSeeFreeMinutes || freeMinutes === 0) {
            setRemainingFreeSeconds(0);
            return;
        }
        var countDownFreeTime = setInterval(function() {
            var rmFreeSecs = Math.round(Math.max(0, freeMinutes * 60 - (0,utils/* secondsToNow */.US)(new Date(startedAt)) - 1));
            setRemainingFreeSeconds(rmFreeSecs);
            if (rmFreeSecs === 0) handleStopFreeTimes();
        }, 1000);
        return function() {
            return clearInterval(countDownFreeTime);
        };
    }, [
        canSeeFreeMinutes,
        freeMinutes,
        startedAt,
        handleStopFreeTimes
    ]);
    // Autoplay
    var intersectionCb = (0,react.useCallback)(function(entries) {
        var aTimeout, bTImeout;
        if (disableAutoPlayOnFocus) return;
        var target = entries[0];
        if (target && target.isIntersecting) {
            // CENTER: entering the middle 10% of screen height
            // TOP: over 30% of video is shown and user has not intentionally paused the video
            if (!isLocked) {
                aTimeout = setTimeout(function() {
                    var ref;
                    var light = (ref = playerWrapperRef.current) === null || ref === void 0 ? void 0 : ref.querySelector(".react-player__preview");
                    if (light) {
                        light.click();
                    }
                }, 500);
                bTImeout = setTimeout(function() {
                    setPlaying(true);
                }, 2000);
            }
        } else {
            // CENTER: leaving the middle 10% of screen height
            // TOP: under 30% of video is shown
            setPlaying(false);
            if (playerRef.current) {
                // This is the key to keeping the player in light mode
                playerRef.current.showPreview();
            }
        }
        return function() {
            aTimeout && clearTimeout(aTimeout);
            bTImeout && clearTimeout(bTImeout);
        };
    }, [
        disableAutoPlayOnFocus,
        isLocked
    ]);
    (0,react.useEffect)(function() {
        if (isLocked || isFullscreen || !isMounted) return;
        var ref = playerWrapperRef.current;
        var options = {
            root: null,
            rootMargin: "0px",
            threshold: 0.3
        };
        // Create observer
        var observer = new IntersectionObserver(intersectionCb, options);
        // observe the audio player
        if (ref) {
            observer.observe(ref);
        }
        // clean up on willUnMount
        return function() {
            if (ref) {
                observer.unobserve(ref);
            }
        };
    // Note: for some reason playerWrapperRef.current needs to be in the dependency array
    // otherwise initial target.isIntersecting will always be false
    }, [
        intersectionCb,
        isLocked,
        playerWrapperRef,
        isFullscreen,
        isMounted
    ]);
    (0,react.useEffect)(function() {
        void (0,livestream/* joinStream */.le)(streamId);
        return function() {
            void (0,livestream/* leaveStream */.d5)(streamId);
            setIsBuffering(false);
        };
    }, [
        streamId
    ]);
    // Media control overlay
    var mediaControlBtn = (0,react.useMemo)(function() {
        var btn;
        if (!playing) {
            btn = /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (LiveStreamPlayer_module_default()).playWrapper,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (LiveStreamPlayer_module_default()).centerBtn,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.ZP, {
                        name: "play",
                        width: 96,
                        height: 96,
                        onClick: function() {
                            return setPlaying(true);
                        }
                    })
                })
            });
        } else if (!isFullscreen && playing) {
            btn = /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: classnames_default()((LiveStreamPlayer_module_default()).playWrapper, (LiveStreamPlayer_module_default()).pauseBtn),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (LiveStreamPlayer_module_default()).centerBtn,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.ZP, {
                        name: "pause",
                        width: 96,
                        height: 96,
                        onClick: function() {
                            return setPlaying(false);
                        }
                    })
                })
            });
        }
        return btn;
    }, [
        isFullscreen,
        playing
    ]);
    var handleSpeakerBtnClick = function(e) {
        e.stopPropagation();
        setMuted(function(muted) {
            return !muted;
        });
        if (playing && muted) {
            setActiveAudioPlayer("video", false);
        }
    };
    // Volume
    var handleVolumeChange = (0,react.useCallback)(function(e, newVolume) {
        e.stopPropagation();
        if (!currentAuth || isLocked) return;
        if (!(0,utils/* isNumber */.hj)(newVolume) || Array.isArray(newVolume)) {
            newVolume = 0.5;
        }
        if (newVolume < 0.025) {
            setMuted(true);
        } else {
            setMuted(false);
            setVolume(newVolume);
            if (playing) {
                setActiveAudioPlayer("video", false);
            }
        }
    }, [
        currentAuth,
        isLocked,
        playing,
        setActiveAudioPlayer
    ]);
    var handleClickFullscreen = function(e) {
        var ref, ref1;
        e.stopPropagation();
        if (isLocked) return;
        try {
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            if (document.exitFullscreen && document.mozFullScreen) {
                void document.exitFullscreen();
            }
        // eslint-disable-next-line no-empty
        } catch (error) {}
        if (!isMobileScreen) {
            void toggleFullscreen(playerWrapperRef.current);
            return;
        }
        /* eslint-disable @typescript-eslint/ban-ts-comment */ // @ts-ignore
        var elem = (ref1 = (ref = playerRef.current) === null || ref === void 0 ? void 0 : ref.wrapper) === null || ref1 === void 0 ? void 0 : ref1.querySelector("video");
        // @ts-ignore
        if (elem && elem.webkitEnterFullScreen) {
            // @ts-ignore
            // eslint-disable-next-line @typescript-eslint/no-unsafe-call
            elem.webkitEnterFullScreen();
        } else void toggleFullscreen(playerWrapperRef.current);
    /* eslint-enable @typescript-eslint/ban-ts-comment */ };
    var stopPropagation = function(e) {
        e.stopPropagation();
    };
    var handleOverlayClick = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(e) {
            var ref, ref1, ref2, selection;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        ;
                        stopPropagation(e);
                        if (isLiveStreamDetail) {
                            _ctx.next = 13;
                            break;
                        }
                        if (currentAuth) {
                            _ctx.next = 6;
                            break;
                        }
                        showLogin({});
                        return _ctx.abrupt("return");
                    case 6:
                        if (isPostDetail) {
                            _ctx.next = 10;
                            break;
                        }
                        _ctx.next = 9;
                        return router.push("/".concat(postAuthor.username, "/posts/").concat(id));
                    case 9:
                        return _ctx.abrupt("return");
                    case 10:
                        if (!isLocked) {
                            _ctx.next = 13;
                            break;
                        }
                        handleTrialClick();
                        return _ctx.abrupt("return");
                    case 13:
                        if (!(freeTimesRef === null || freeTimesRef === void 0 ? void 0 : (ref = freeTimesRef.current) === null || ref === void 0 ? void 0 : ref.contains(e.target))) {
                            _ctx.next = 15;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 15:
                        selection = window.getSelection();
                        if (selection.type != "Range" && !(bottomBarRef === null || bottomBarRef === void 0 ? void 0 : (ref1 = bottomBarRef.current) === null || ref1 === void 0 ? void 0 : ref1.contains(e.target)) && !(mediaControlRef === null || mediaControlRef === void 0 ? void 0 : (ref2 = mediaControlRef.current) === null || ref2 === void 0 ? void 0 : ref2.contains(e.target))) {
                            setPlaying(function(playing) {
                                return !playing;
                            });
                            if (!playing) {
                                setActiveAudioPlayer("video", false);
                            }
                        }
                    case 17:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleOverlayClick(e) {
            return _ref.apply(this, arguments);
        };
    }();
    var reactPlayerStyle = (0,react.useMemo)(function() {
        var style;
        if (isFullscreen || isFullScreenBrowser) {
            style = {
                position: "absolute",
                top: 0,
                bottom: 0,
                left: 0,
                right: 0
            };
        } else {
            style = {};
        }
        return style;
    }, [
        isFullScreenBrowser,
        isFullscreen
    ]);
    var handleTrialClick = function() {
        if (postType === api/* PostType.Gold */.hQ.Gold && !(0,membership/* isGoldMember */.Ic)(currentUser)) {
            setShowMembershipPayDialog({
                open: true,
                showMembershipStatus: false,
                initPackage: api/* MembershipPackageName.Platinum */.uh.Platinum,
                screen: pp_tracking/* ScreenName.PostDetail */.CG.PostDetail
            });
            return;
        }
        if (!postAuthor) return;
        // in case of value is undefined, still can open payment dialog
        if (postAuthor.is_open_for_subscription === false && (0,post/* checkIsCreatorPaidPost */.b8)(postType)) {
            setSnackbarMessage({
                type: "error",
                text: (0,post/* exCreatorPostLockMessage */.e8)(postType)
            });
            return;
        }
        showPaymentDialog({
            creator: postAuthor
        });
    };
    (0,react.useEffect)(function() {
        if (isMobileScreen && !isLocked) return;
        if (isHover && !isLocked) {
            var ref;
            var light = (ref = playerWrapperRef.current) === null || ref === void 0 ? void 0 : ref.querySelector(".react-player__preview");
            if (light) {
                light.click();
            }
        }
    }, [
        isHover,
        isLocked,
        isMobileScreen
    ]);
    (0,react.useEffect)(function() {
        if (isMobileScreen && !isLocked) return;
        var timeOut = setTimeout(function() {
            var img = new Image();
            img.onload = function() {
                if (!playerWrapperRef.current) return;
                var light = playerWrapperRef.current.querySelector(".react-player__preview");
                var wrapperWidth = playerWrapperRef.current.clientWidth;
                if (light) {
                    light.style.minHeight = "".concat(wrapperWidth / img.width * img.height, "px");
                }
            };
            img.src = thumbnail;
        }, 600);
        return function() {
            return clearTimeout(timeOut);
        };
    }, [
        thumbnail,
        isMobileScreen,
        isLocked
    ]);
    var seekToLast = function() {
        if (!playerRef.current) return;
        var playerDuration = playerRef.current.getDuration();
        if (isNaN(playerDuration)) {
            if (isNaN(displayDuration)) {
                playerRef.current.seekTo(1, "fraction");
            } else {
                playerRef.current.seekTo(Math.floor(displayDuration + startPosition - 2));
            }
        } else {
            playerRef.current.seekTo(Math.floor(playerDuration - 1));
        }
    };
    var seekPercent = realDuration - realPlayedSeconds <= 10 ? 100 : Math.min(Math.ceil(timebarVal * 100), 100);
    var isWatchingLive = realDuration - realPlayedSeconds <= 10;
    var _obj;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: classnames_default()((LiveStreamPlayer_module_default()).playerWrapper, (0,_define_property/* default */.Z)({}, (LiveStreamPlayer_module_default()).fullscreenVideo, isFullscreen || isFullScreenBrowser)),
        ref: playerWrapperRef,
        onMouseLeave: function() {
            return setIsHover(false);
        },
        onMouseEnter: function() {
            return setIsHover(true);
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)((lazy_default()), {
                width: "100%",
                height: "100%",
                style: reactPlayerStyle,
                ref: playerRef,
                onBuffer: function() {
                    return setIsBuffering(true);
                },
                onBufferEnd: function() {
                    return setIsBuffering(false);
                },
                onPlay: function() {
                    return setIsBuffering(false);
                },
                url: url,
                muted: isPostDetail || isLiveStreamDetail ? muted : true,
                volume: volume,
                playsinline: true,
                playing: playing && isReady && isMounted,
                onStart: function() {
                    setTimeout(function() {
                        seekToLast();
                    }, 1000);
                },
                onProgress: handleProgress,
                onError: function() {
                    if (!isReady) return;
                    setTimeout(function() {
                        setPlaying(true);
                    }, 2000);
                },
                onReady: function() {
                    return setIsReady(true);
                },
                light: (isMobileScreen || disableAutoPlayOnFocus) && !isLocked ? false : thumbnail,
                config: {
                    file: {
                        attributes: {
                            poster: thumbnail
                        },
                        hlsOptions: {
                            // eslint-disable-next-line @typescript-eslint/no-unused-vars
                            xhrSetup: function xhrSetup(xhr) {
                            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
                            // xhr.withCredentials = true; // send cookies
                            },
                            maxLoadingDelay: 4,
                            minAutoBitrate: 0,
                            lowLatencyMode: true,
                            startPosition: startPosition
                        }
                    }
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: classnames_default()((LiveStreamPlayer_module_default()).playerOverlay, (_obj = {}, (0,_define_property/* default */.Z)(_obj, (LiveStreamPlayer_module_default()).fullscreen, isFullscreen || isFullScreenBrowser), (0,_define_property/* default */.Z)(_obj, (LiveStreamPlayer_module_default()).notPostDetail, !isPostDetail || !currentAuth), (0,_define_property/* default */.Z)(_obj, (LiveStreamPlayer_module_default()).isLiveStreamDetail, isLiveStreamDetail), _obj)),
                onClick: handleOverlayClick,
                children: [
                    isLive && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (LiveStreamPlayer_module_default()).streamInfo,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (LiveStreamPlayer_module_default()).streamLabel,
                                children: "LIVE"
                            }),
                            isLiveStreamDetail && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (LiveStreamPlayer_module_default()).viewerCount,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.ZP, {
                                        name: "eye",
                                        width: 22,
                                        height: 22
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: (0,utils/* coinNumberToString */.dR)(viewerCount)
                                    })
                                ]
                            })
                        ]
                    }),
                    isBuffering && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (LiveStreamPlayer_module_default()).buffering,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.ZP, {
                            name: "loading-spinner",
                            width: 44,
                            height: 44
                        })
                    }),
                    canSeeFreeMinutes && isPostDetail && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (LiveStreamPlayer_module_default()).remainingFreeTime,
                        ref: freeTimesRef,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                children: [
                                    "残り",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: (LiveStreamPlayer_module_default()).time,
                                        children: (0,utils/* secondsToHms */.qt)(Math.max(remainingFreeSeconds, 0))
                                    }),
                                    "プライム投稿に変更されます"
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                text: "プライム登録を無料体験",
                                onClick: function(e) {
                                    showPaymentDialog({
                                        creator: postAuthor
                                    });
                                    if (isFullscreen || isFullScreenBrowser) {
                                        handleClickFullscreen(e);
                                    }
                                }
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (LiveStreamPlayer_module_default()).mediaControlBtn,
                        ref: mediaControlRef,
                        children: mediaControlBtn
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (LiveStreamPlayer_module_default()).bottomBar,
                        ref: bottomBarRef,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (LiveStreamPlayer_module_default()).timeBarSection,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (LiveStreamPlayer_module_default()).timebar,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                        type: "range",
                                        min: 0,
                                        max: 1,
                                        step: 0.001,
                                        value: timebarVal,
                                        style: {
                                            background: "linear-gradient(to right, #FF2D55 0%, #FF2D55 ".concat(seekPercent, "%, #aeaeae ").concat(seekPercent, "%, #aeaeae 100%)")
                                        },
                                        onChange: handleTimebarChange,
                                        className: (LiveStreamPlayer_module_default()).sliderTime,
                                        onMouseDown: function() {
                                            return setIsMouseDowningTimeBar(true);
                                        },
                                        onMouseUp: function() {
                                            setTimeout(function() {
                                                setIsMouseDowningTimeBar(false);
                                            }, 100);
                                        }
                                    }, "video-time-slider-".concat(id))
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (LiveStreamPlayer_module_default()).controlButtons,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (LiveStreamPlayer_module_default()).leftCorner,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: (LiveStreamPlayer_module_default()).playTime,
                                                children: (0,utils/* secondsToHms */.qt)(displayPlayedSeconds)
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: (LiveStreamPlayer_module_default()).volumeCtrl,
                                                onClick: stopPropagation,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: (LiveStreamPlayer_module_default()).speakerBtn,
                                                        onClick: handleSpeakerBtnClick,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.ZP, {
                                                            name: "speaker",
                                                            width: 26,
                                                            height: 26,
                                                            hasOn: true,
                                                            isOn: !muted
                                                        })
                                                    }),
                                                    !isMobileScreen && /*#__PURE__*/ (0,jsx_runtime.jsx)(Slider/* default */.Z, {
                                                        defaultValue: 1,
                                                        min: 0,
                                                        max: 1,
                                                        step: 0.025,
                                                        onChange: handleVolumeChange,
                                                        className: (LiveStreamPlayer_module_default()).volumeSlider
                                                    }, "video-slider-".concat(id))
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: (LiveStreamPlayer_module_default()).liveText,
                                                onClick: function() {
                                                    if (!isWatchingLive) {
                                                        seekToLast();
                                                    }
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* CircleIcon */.J$, {
                                                        width: 6,
                                                        height: 6,
                                                        color: isWatchingLive ? "#FF2D55" : "#aeaeae"
                                                    }),
                                                    "ライブ"
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (LiveStreamPlayer_module_default()).rightCorner,
                                        children: !isMobileScreen && deviceInfo.isDesktop && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: (LiveStreamPlayer_module_default()).fullscreenBtn,
                                            onClick: handleClickFullscreen,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.ZP, {
                                                        name: "fullscreen",
                                                        width: 17,
                                                        height: 17
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: (LiveStreamPlayer_module_default()).fullscreenText,
                                                    children: isFullscreen ? "全画面を閉じる" : "全画面で見る"
                                                })
                                            ]
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};

// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Dialog/Dialog.js + 2 modules
var Dialog = __webpack_require__(93579);
// EXTERNAL MODULE: ./components/common/ImagePreviewDialog/ImagePreviewDialog.module.scss
var ImagePreviewDialog_module = __webpack_require__(77088);
var ImagePreviewDialog_module_default = /*#__PURE__*/__webpack_require__.n(ImagePreviewDialog_module);
;// CONCATENATED MODULE: ./components/common/ImagePreviewDialog/index.tsx




function ImagePreviewDialog(param) {
    var imgSrc = param.imgSrc, open = param.open, setOpen = param.setOpen;
    // Close the dialog when clicking anywhere except for the image
    var ignoreAction = function(e) {
        e.stopPropagation();
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Dialog/* default */.Z, {
        fullScreen: true,
        open: open,
        onClose: function() {
            return setOpen(false);
        },
        onClick: function() {
            return setOpen(false);
        },
        PaperProps: {
            style: {
                backgroundColor: "transparent",
                boxShadow: "none"
            }
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (ImagePreviewDialog_module_default()).dialogWrapper,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (ImagePreviewDialog_module_default()).closeBtn,
                    onClick: function() {
                        return setOpen(false);
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.ZP, {
                        name: "close",
                        width: 32,
                        height: 32
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    src: imgSrc,
                    className: (ImagePreviewDialog_module_default()).image,
                    onClick: ignoreAction,
                    onContextMenu: function(e) {
                        return e.preventDefault();
                    }
                })
            ]
        })
    });
};

// EXTERNAL MODULE: ./components/common/ViewedContent/index.tsx
var ViewedContent = __webpack_require__(85631);
// EXTERNAL MODULE: ./components/MediaContent/MediaContent.module.scss
var MediaContent_module = __webpack_require__(71397);
var MediaContent_module_default = /*#__PURE__*/__webpack_require__.n(MediaContent_module);
// EXTERNAL MODULE: ./service/ads_tracking.ts
var ads_tracking = __webpack_require__(82752);
// EXTERNAL MODULE: ./node_modules/react-query/es/index.js
var es = __webpack_require__(88767);
// EXTERNAL MODULE: ./lib/dayjs.ts
var dayjs = __webpack_require__(25916);
// EXTERNAL MODULE: ./components/common/BigButton/index.tsx
var BigButton = __webpack_require__(77041);
// EXTERNAL MODULE: ./service/user.ts
var service_user = __webpack_require__(8193);
;// CONCATENATED MODULE: ./components/MediaContent/index.tsx






























var MediaContent = function(param) {
    var localPost = param.localPost, isContentLocked = param.isContentLocked, sharedPost = param.sharedPost, setSharedPost = param.setSharedPost, parent = param.parent, _isPostDetail = param.isPostDetail, isPostDetail = _isPostDetail === void 0 ? false : _isPostDetail, isMobileScreen = param.isMobileScreen, _isLitePost = param.isLitePost, isLitePost = _isLitePost === void 0 ? false : _isLitePost, canSeeFreeMinutes = param.canSeeFreeMinutes, setCanSeeFreeMinutes = param.setCanSeeFreeMinutes, loadedPostWithAuth = param.loadedPostWithAuth;
    if (localPost.streaming) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: classnames_default()((MediaContent_module_default()).mediaHeader, (0,_define_property/* default */.Z)({}, (MediaContent_module_default()).isPostDetail, isPostDetail)),
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MediaLiveStream, {
                localPost: localPost,
                isMobileScreen: isMobileScreen,
                isContentLocked: isContentLocked,
                isPostDetail: isPostDetail,
                canSeeFreeMinutes: canSeeFreeMinutes,
                setCanSeeFreeMinutes: setCanSeeFreeMinutes,
                loadedPostWithAuth: loadedPostWithAuth,
                parent: parent
            })
        });
    }
    if (!localPost.media || !localPost.media[0]) return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    var postContent = function() {
        switch(localPost.media[0].type){
            case api/* MediaType.Video */.DD.Video:
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(MediaVideo, {
                    localPost: localPost,
                    isContentLocked: isContentLocked,
                    isMobileScreen: isMobileScreen,
                    isPostDetail: isPostDetail,
                    canSeeFreeMinutes: canSeeFreeMinutes,
                    setCanSeeFreeMinutes: setCanSeeFreeMinutes,
                    parent: parent
                });
            case api/* MediaType.Image */.DD.Image:
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(MediaImage, {
                    localPost: localPost,
                    isContentLocked: isContentLocked,
                    isMobileScreen: isMobileScreen,
                    isPostDetail: isPostDetail,
                    parent: parent
                });
            case api/* MediaType.Link */.DD.Link:
                if (localPost.is_affiliate) return /*#__PURE__*/ (0,jsx_runtime.jsx)(MediaAds, {
                    localPost: localPost,
                    parent: parent,
                    isPostDetail: isPostDetail
                });
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(MediaLink, {
                    localPost: localPost,
                    sharedPost: sharedPost,
                    setSharedPost: setSharedPost,
                    isLitePost: isLitePost
                });
            case api/* MediaType.Audio */.DD.Audio:
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(MediaAudio, {
                    localPost: localPost,
                    isContentLocked: isContentLocked,
                    parent: parent,
                    isPostDetail: isPostDetail,
                    canSeeFreeMinutes: canSeeFreeMinutes,
                    setCanSeeFreeMinutes: setCanSeeFreeMinutes
                });
            default:
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: classnames_default()((MediaContent_module_default()).mediaHeader, (0,_define_property/* default */.Z)({}, (MediaContent_module_default()).isPostDetail, isPostDetail)),
        children: postContent()
    });
};
var MediaVideo = function(param) {
    var localPost = param.localPost, isContentLocked = param.isContentLocked, isMobileScreen = param.isMobileScreen, _isPostDetail = param.isPostDetail, isPostDetail = _isPostDetail === void 0 ? false : _isPostDetail, _canSeeFreeMinutes = param.canSeeFreeMinutes, canSeeFreeMinutes = _canSeeFreeMinutes === void 0 ? false : _canSeeFreeMinutes, setCanSeeFreeMinutes = param.setCanSeeFreeMinutes, parent = param.parent;
    var ref;
    var currentAuth = (0,global/* default */.Z)(function(state) {
        return state.currentAuth;
    });
    var currentUser = (0,timeline/* default */.ZP)(function(state) {
        return state.currentUser;
    });
    var setShowMembershipPayDialog = (0,global/* default */.Z)(function(state) {
        return state.setShowMembershipPayDialog;
    });
    var showLogin = (0,global/* default */.Z)(function(state) {
        return state.showLogin;
    });
    var setSnackbarMessage = (0,global/* default */.Z)(function(state) {
        return state.setSnackbarMessage;
    });
    var ref1 = (0,react.useState)(false), isScale = ref1[0], setIsScale = ref1[1];
    var showPaymentDialog = (0,global/* default */.Z)(function(state) {
        return state.showPaymentDialog;
    });
    var router = (0,next_router.useRouter)();
    var postDetailsUrl = "/".concat((ref = localPost.user_info) === null || ref === void 0 ? void 0 : ref.username, "/posts/").concat(localPost.id);
    var isVideoLocked = isContentLocked && !canSeeFreeMinutes;
    var showingVideo = !isVideoLocked && !(isMobileScreen && !isPostDetail) && localPost.status === api/* PostState.Activated */.hA.Activated;
    (0,react.useEffect)(function() {
        setCanSeeFreeMinutes(currentAuth && isContentLocked && localPost.free_minutes > 0 && localPost.media[0].data.free_version && !!localPost.media[0].data.duration);
    }, [
        currentAuth,
        isContentLocked,
        setCanSeeFreeMinutes,
        localPost.free_minutes,
        localPost.media, 
    ]);
    var handleStopFreeTimes = function() {
        setCanSeeFreeMinutes(false);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: classnames_default()((MediaContent_module_default()).mediaWrapper, (MediaContent_module_default()).isVideo, (0,_define_property/* default */.Z)({}, (MediaContent_module_default()).scaleMaxHeight, isScale && !showingVideo)),
        children: showingVideo ? /*#__PURE__*/ (0,jsx_runtime.jsx)(VideoPlayer, {
            id: localPost.id,
            url: localPost.media[0].data.url,
            thumbnail: localPost.media[0].data.thumbnail_url,
            postAuthor: localPost.user_info,
            isLocked: isVideoLocked,
            postState: localPost.status,
            isPostDetail: isPostDetail,
            autoplayOnMount: isPostDetail,
            autoplayThreshold: AutoplayThreshold.Center,
            disableAutoPlayOnFocus: isPostDetail,
            postType: localPost.type,
            canSeeFreeMinutes: canSeeFreeMinutes,
            freeUrl: localPost.media[0].data.free_version,
            freeMinutes: localPost.free_minutes,
            handleStopFreeTimes: handleStopFreeTimes,
            fullDuration: localPost.media[0].data.duration,
            parent: parent,
            postSource: localPost.source
        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
            onClick: function() {
                if (!isPostDetail) {
                    void router.push(postDetailsUrl);
                    if (!isPostDetail) {
                        (0,post/* addClickPostEvent */.lR)({
                            postId: localPost.id,
                            screen: (0,pp_tracking/* parentKeyToScreenName */.lF)(parent),
                            postSource: localPost.source,
                            clickPosition: "media_view",
                            postType: localPost.type,
                            mediaType: api/* MediaType.Video */.DD.Video
                        });
                    }
                    return;
                }
                if (!currentAuth) {
                    showLogin({
                        redirectUrl: postDetailsUrl
                    });
                    return;
                }
                if (localPost.status === api/* PostState.OnProcessing */.hA.OnProcessing) {
                    setSnackbarMessage({
                        type: "warning",
                        text: "処理中のビデオを再生できません",
                        autoHideDuration: 6000
                    });
                    return;
                }
                if (isContentLocked && localPost.type === api/* PostType.Gold */.hQ.Gold && !(0,membership/* isGoldMember */.Ic)(currentUser)) {
                    setShowMembershipPayDialog({
                        open: true,
                        showMembershipStatus: false,
                        initPackage: api/* MembershipPackageName.Platinum */.uh.Platinum,
                        screen: pp_tracking/* ScreenName.PostDetail */.CG.PostDetail
                    });
                    return;
                }
                if (isContentLocked && isPostDetail && (0,post/* checkIsCreatorPaidPost */.b8)(localPost.type)) {
                    if (localPost.user_info.is_open_for_subscription === false) {
                        setSnackbarMessage({
                            type: "error",
                            text: (0,post/* exCreatorPostLockMessage */.e8)(localPost.type)
                        });
                        return;
                    }
                    showPaymentDialog({
                        creator: localPost.user_info
                    });
                    return;
                }
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (MediaContent_module_default()).mediaControlBtn,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.ZP, {
                        name: "play",
                        width: 96,
                        height: 96
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    loading: "lazy",
                    src: localPost.media[0].data.thumbnail_url,
                    alt: (0,post/* altImageOfPost */.Oq)(localPost.text),
                    onLoad: function(e) {
                        var img = e.target;
                        if (!img) return;
                        if (img.naturalHeight > img.naturalWidth / 1.2) {
                            setIsScale(true);
                        }
                    }
                }),
                localPost.status === api/* PostState.OnProcessing */.hA.OnProcessing && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (MediaContent_module_default()).processingLabel,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.ZP, {
                            name: "waiting",
                            width: 44,
                            height: 44
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (MediaContent_module_default()).text,
                            children: "処理中のため、少しお待ちください。"
                        })
                    ]
                })
            ]
        })
    });
};
var MediaImage = function(param) {
    var localPost = param.localPost, isContentLocked = param.isContentLocked, isMobileScreen = param.isMobileScreen, isPostDetail = param.isPostDetail, parent = param.parent;
    var ref;
    // Image preview dialog
    var ref1 = (0,react.useState)(null), imgSrc = ref1[0], setImgSrc = ref1[1];
    var ref2 = (0,react.useState)(false), openPreview = ref2[0], setOpenPreview = ref2[1];
    var currentAuth = (0,global/* default */.Z)(function(state) {
        return state.currentAuth;
    });
    var showLogin = (0,global/* default */.Z)(function(state) {
        return state.showLogin;
    });
    var router = (0,next_router.useRouter)();
    var postDetailsUrl = "/".concat((ref = localPost.user_info) === null || ref === void 0 ? void 0 : ref.username, "/posts/").concat(localPost.id);
    var handleOpenClick = function(imgSrc) {
        if (!isPostDetail) {
            (0,post/* addClickPostEvent */.lR)({
                postId: localPost.id,
                screen: (0,pp_tracking/* parentKeyToScreenName */.lF)(parent),
                postSource: localPost.source,
                clickPosition: "media_view",
                postType: localPost.type,
                mediaType: api/* MediaType.Image */.DD.Image
            });
            void router.push(postDetailsUrl);
            return;
        }
        if (!currentAuth) {
            showLogin({});
            return;
        }
        if (!isContentLocked) {
            setImgSrc(imgSrc);
            setOpenPreview(true);
        }
    };
    var isScaleMaxHeight = false;
    if (isMobileScreen) {
        isScaleMaxHeight = localPost.media[0].data.height > localPost.media[0].data.width / 0.8;
    } else {
        isScaleMaxHeight = localPost.media[0].data.height > localPost.media[0].data.width / 1.2;
    }
    var isBlur = isContentLocked && !!localPost.media[0].data.blur;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: classnames_default()((MediaContent_module_default()).mediaWrapper, (MediaContent_module_default()).imageMedia, (0,_define_property/* default */.Z)({}, (MediaContent_module_default()).scaleMaxHeight, isScaleMaxHeight)),
                onClick: function() {
                    return handleOpenClick(localPost.media[0].data.url);
                },
                onContextMenu: function(e) {
                    return e.preventDefault();
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: classnames_default()((MediaContent_module_default()).media, (0,_define_property/* default */.Z)({}, (MediaContent_module_default()).blurred, isBlur)),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (MediaContent_module_default()).imageWrapper,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            src: localPost.media[0].data.url,
                            layout: "responsive",
                            priority: isPostDetail,
                            height: localPost.media[0].data.height,
                            width: localPost.media[0].data.width,
                            alt: (0,post/* altImageOfPost */.Oq)(localPost.text)
                        })
                    })
                })
            }),
            openPreview && /*#__PURE__*/ (0,jsx_runtime.jsx)(ImagePreviewDialog, {
                imgSrc: imgSrc,
                open: openPreview,
                setOpen: setOpenPreview
            })
        ]
    });
};
var MediaLink = function(param) {
    var localPost = param.localPost, sharedPost = param.sharedPost, setSharedPost = param.setSharedPost, isLitePost = param.isLitePost;
    var linkThumbnailRef = (0,react.useRef)(null);
    var ref = (0,react.useState)(false), noThumbnail = ref[0], setNoThumbnail = ref[1];
    var ref1 = (0,react.useState)(false), isScale = ref1[0], setIsScale = ref1[1];
    (0,react.useEffect)(function() {
        var ref;
        if (isLitePost) return;
        var fetchSharePost = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(url) {
                var sharedPost;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.next = 2;
                            return (0,utils/* getPostFromUrl */.rb)(url);
                        case 2:
                            sharedPost = _ctx.sent;
                            if (sharedPost) {
                                setSharedPost && setSharedPost(sharedPost);
                            } else {
                                setSharedPost && setSharedPost(null);
                            }
                        case 4:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return function fetchSharePost(url) {
                return _ref.apply(this, arguments);
            };
        }();
        var linkUrl = (ref = localPost.media[0].data) === null || ref === void 0 ? void 0 : ref.url;
        if (!linkUrl) return;
        void fetchSharePost(linkUrl);
    }, [
        localPost,
        setSharedPost,
        isLitePost
    ]);
    if (sharedPost) return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    var _obj;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: classnames_default()((MediaContent_module_default()).mediaWrapper, (MediaContent_module_default()).linkMedia, (_obj = {}, (0,_define_property/* default */.Z)(_obj, (MediaContent_module_default()).linkMediaNoThumbnail, noThumbnail), (0,_define_property/* default */.Z)(_obj, (MediaContent_module_default()).scaleMaxHeight, isScale), _obj)),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
            href: (0,utils/* externalUrlRedirectLink */.tO)(localPost.media[0].data.url),
            target: "_blank",
            rel: "noopener",
            style: {
                width: "100%"
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (MediaContent_module_default()).mediaContainer,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        className: (MediaContent_module_default()).media,
                        loading: "lazy",
                        src: localPost.media[0].data.thumbnail_url,
                        ref: linkThumbnailRef,
                        alt: (0,post/* altImageOfPost */.Oq)(localPost.text),
                        onLoad: function(e) {
                            var img = e.target;
                            if (!img) return;
                            if (img.naturalHeight > img.naturalWidth / 1.2) {
                                setIsScale(true);
                            }
                        },
                        onError: function() {
                            return (0,utils/* loadImageHandleError */.In)(localPost.media[0].data.thumbnail_url, linkThumbnailRef, function() {
                                linkThumbnailRef.current.style.display = "none";
                                setNoThumbnail(true);
                            });
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (MediaContent_module_default()).linkInfo,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (MediaContent_module_default()).linkTitle,
                                children: (0,utils/* truncateStr */.bI)(localPost.media[0].data.title, 60)
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (MediaContent_module_default()).bottomLeft,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (MediaContent_module_default()).linkSrc,
                                    children: localPost.media[0].data.source_name
                                })
                            })
                        ]
                    })
                ]
            })
        })
    });
};
var MediaAudio = function(param) {
    var localPost = param.localPost, isContentLocked = param.isContentLocked, parent = param.parent, _isPostDetail = param.isPostDetail, isPostDetail = _isPostDetail === void 0 ? false : _isPostDetail, canSeeFreeMinutes = param.canSeeFreeMinutes, setCanSeeFreeMinutes = param.setCanSeeFreeMinutes;
    var portalNodes = (0,global/* default */.Z)(function(state) {
        return state.portalNodes;
    });
    var postKey = parent + localPost.id.toString();
    var currentAuth = (0,global/* default */.Z)(function(state) {
        return state.currentAuth;
    });
    // Set up audio player
    var setAudioPlayer = (0,global/* default */.Z)(function(state) {
        return state.setAudioPlayer;
    });
    var activeAudioId = (0,timeline/* default */.ZP)(function(state) {
        var ref;
        return (ref = state.activeAudioPlayer) === null || ref === void 0 ? void 0 : ref.id;
    });
    var activeAudioIdRef = (0,react.useRef)(null);
    activeAudioIdRef.current = activeAudioId;
    (0,react.useEffect)(function() {
        setAudioPlayer(postKey, {
            id: localPost.id,
            url: localPost.media[0].data.url || utils/* AUDIO_TMP_URL */.Qk,
            trackTitle: localPost.media[0].data.title,
            postAuthor: localPost.user_info,
            removed: false,
            parent: parent,
            spectrum: localPost.media[0].data.spectrum,
            duration: localPost.media[0].data.duration,
            thumbnailUrl: localPost.media[0].data.thumbnail_url,
            canSeeFreeMinutes: canSeeFreeMinutes,
            isLocked: isContentLocked,
            freeMinutes: localPost.free_minutes,
            freeUrl: localPost.media[0].data.free_version,
            isPostDetail: isPostDetail,
            postType: localPost.type,
            postSource: localPost.source
        });
        return function() {
            if (postKey !== activeAudioIdRef.current) setAudioPlayer(postKey, null);
            else setAudioPlayer(postKey, {
                removed: true
            });
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        localPost.media,
        localPost.free_minutes,
        localPost.id,
        postKey,
        setAudioPlayer,
        parent,
        canSeeFreeMinutes,
        localPost.user_info,
        isContentLocked,
        isPostDetail,
        localPost.type, 
    ]);
    (0,react.useEffect)(function() {
        setCanSeeFreeMinutes(currentAuth && isContentLocked && localPost.free_minutes > 0 && localPost.media[0].data.free_version && !!localPost.media[0].data.duration);
    }, [
        isContentLocked,
        setCanSeeFreeMinutes,
        localPost.free_minutes,
        localPost.media,
        currentAuth, 
    ]);
    if (!portalNodes[postKey]) return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (MediaContent_module_default()).mediaWrapper,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(web/* OutPortal */.t0, {
            node: portalNodes[postKey]
        })
    });
};
var MediaAds = function(param) {
    var localPost = param.localPost, parent = param.parent, _isPostDetail = param.isPostDetail, isPostDetail = _isPostDetail === void 0 ? false : _isPostDetail;
    var linkThumbnailRef = (0,react.useRef)(null);
    var ref = (0,react.useState)(false), noThumbnail = ref[0], setNoThumbnail = ref[1];
    var ref1 = (0,react.useState)(false), isScale = ref1[0], setIsScale = ref1[1];
    var handleFirstImpression = function() {
        if (isPostDetail) return;
        (0,ads_tracking/* adsTrackingCall */.E)({
            type: "ads_impression",
            parentType: parent,
            postId: localPost.id
        });
    };
    var handleClickLinkAds = function() {
        (0,ads_tracking/* adsTrackingCall */.E)({
            type: "ads_click",
            parentType: parent,
            postId: localPost.id
        });
    };
    var _obj;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ViewedContent/* default */.Z, {
        firstViewCallback: handleFirstImpression,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: classnames_default()((MediaContent_module_default()).mediaWrapper, (MediaContent_module_default()).linkMedia, (MediaContent_module_default()).adsPost, (_obj = {}, (0,_define_property/* default */.Z)(_obj, (MediaContent_module_default()).linkMediaNoThumbnail, noThumbnail), (0,_define_property/* default */.Z)(_obj, (MediaContent_module_default()).scaleMaxHeight, isScale), _obj)),
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                href: (0,utils/* externalUrlRedirectLink */.tO)(localPost.media[0].data.url),
                target: "_blank",
                rel: "noopener",
                style: {
                    width: "100%"
                },
                onClick: function() {
                    return handleClickLinkAds();
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (MediaContent_module_default()).mediaContainer,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            className: (MediaContent_module_default()).media,
                            loading: "lazy",
                            src: localPost.media[0].data.thumbnail_url,
                            ref: linkThumbnailRef,
                            onLoad: function(e) {
                                var img = e.target;
                                if (!img) return;
                                if (img.naturalHeight > img.naturalWidth / 1.2) {
                                    setIsScale(true);
                                }
                            },
                            alt: (0,post/* altImageOfPost */.Oq)(localPost.text),
                            onError: function() {
                                return (0,utils/* loadImageHandleError */.In)(localPost.media[0].data.thumbnail_url, linkThumbnailRef, function() {
                                    linkThumbnailRef.current.style.display = "none";
                                    setNoThumbnail(true);
                                });
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (MediaContent_module_default()).linkInfo,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (MediaContent_module_default()).linkTitle,
                                children: localPost.media[0].data.title
                            })
                        })
                    ]
                })
            })
        })
    });
};
var RegistryNotification = function(param) {
    var user = param.user;
    var refetchCurrentProfile = (0,timeline/* default */.ZP)(function(state) {
        return state.refetchCurrentProfile;
    });
    var setSnackbarMessage = (0,global/* default */.Z)(function(state) {
        return state.setSnackbarMessage;
    });
    var currentUser = (0,timeline/* default */.ZP)(function(state) {
        return state.currentUser;
    });
    var ref = (0,react.useState)(false), done = ref[0], setDone = ref[1];
    if (done || !user || !currentUser || currentUser.id === user.id || !user.is_turn_on_notification_btn) return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    var isFollow = user.is_followed;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (MediaContent_module_default()).notifyBtn,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BigButton/* default */.Z, {
            text: "通知ON",
            onText: "通知OFF",
            // icon="bell-follow-orange"
            fadeColorWhenOn: true,
            // alternateColor
            fullWidth: true,
            // bigGuyStyle
            onClick: function() {
                var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(e) {
                    return runtime_default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                _ctx.prev = 0;
                                e.preventDefault();
                                if (isFollow) {
                                    _ctx.next = 5;
                                    break;
                                }
                                _ctx.next = 5;
                                return (0,service_user/* handleFollowAction */.eW)(user.id, "follow");
                            case 5:
                                _ctx.next = 7;
                                return (0,service_user/* handleRegistryNotificationAction */.x1)(user.username, "post");
                            case 7:
                                refetchCurrentProfile();
                                setDone(true);
                                setSnackbarMessage({
                                    type: "success",
                                    text: "通知をONにしました"
                                });
                                _ctx.next = 15;
                                break;
                            case 12:
                                _ctx.prev = 12;
                                _ctx.t0 = _ctx["catch"](0);
                                setDone(true);
                            case 15:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee, null, [
                        [
                            0,
                            12
                        ]
                    ]);
                }));
                return function(e) {
                    return _ref.apply(this, arguments);
                };
            }()
        })
    });
};
var MediaLiveStream = function(param) {
    var localPost = param.localPost, isContentLocked = param.isContentLocked, _isPostDetail = param.isPostDetail, isPostDetail = _isPostDetail === void 0 ? false : _isPostDetail, isMobileScreen = param.isMobileScreen, _canSeeFreeMinutes = param.canSeeFreeMinutes, canSeeFreeMinutes = _canSeeFreeMinutes === void 0 ? false : _canSeeFreeMinutes, setCanSeeFreeMinutes = param.setCanSeeFreeMinutes, loadedPostWithAuth = param.loadedPostWithAuth, parent = param.parent;
    var ref, ref1;
    var currentAuth = (0,global/* default */.Z)(function(state) {
        return state.currentAuth;
    });
    var isAuthInit = (0,global/* default */.Z)(function(state) {
        return state.isAuthInit;
    });
    var showLogin = (0,global/* default */.Z)(function(state) {
        return state.showLogin;
    });
    var setSnackbarMessage = (0,global/* default */.Z)(function(state) {
        return state.setSnackbarMessage;
    });
    var currentUser = (0,timeline/* default */.ZP)(function(state) {
        return state.currentUser;
    });
    var setShowMembershipPayDialog = (0,global/* default */.Z)(function(state) {
        return state.setShowMembershipPayDialog;
    });
    var ref2 = (0,react.useState)(false), isScale = ref2[0], setIsScale = ref2[1];
    var ref3 = (0,react.useState)(0), viewerCount = ref3[0], setViewerCount = ref3[1];
    var showPaymentDialog = (0,global/* default */.Z)(function(state) {
        return state.showPaymentDialog;
    });
    var refetchPost = (0,timeline/* default */.ZP)(function(state) {
        return state.refetchPost;
    });
    var router = (0,next_router.useRouter)();
    var linkThumbnailRef = (0,react.useRef)(null);
    var streamData = localPost.streaming;
    var isStreaming = (streamData === null || streamData === void 0 ? void 0 : streamData.status) === api/* LiveStreamStatus.InLive */.zN.InLive && !!(streamData === null || streamData === void 0 ? void 0 : streamData.path_hls);
    var beforeLiveRef = (0,react.useRef)();
    (0,react.useEffect)(function() {
        setCanSeeFreeMinutes(currentAuth && isStreaming && isContentLocked && (localPost === null || localPost === void 0 ? void 0 : localPost.free_minutes) > 0 && !!(streamData === null || streamData === void 0 ? void 0 : streamData.delivery_started_at) && (0,utils/* secondsToNow */.US)(new Date(streamData.delivery_started_at)) < (localPost === null || localPost === void 0 ? void 0 : localPost.free_minutes) * 60);
    }, [
        currentAuth,
        isContentLocked,
        isStreaming,
        setCanSeeFreeMinutes,
        streamData.delivery_started_at,
        localPost === null || localPost === void 0 ? void 0 : localPost.free_minutes, 
    ]);
    var handleStopFreeTimes = function() {
        setCanSeeFreeMinutes(false);
    };
    var showingThumbnail = !currentAuth || isMobileScreen && !isPostDetail || (isContentLocked || !isStreaming) && !canSeeFreeMinutes;
    var ref4 = (0,react.useState)(false), noThumbnail = ref4[0], setNoThumbnail = ref4[1];
    var planStartTime = (streamData === null || streamData === void 0 ? void 0 : streamData.planned_to_start_at) || new Date().toISOString();
    var fetchStreamData = (0,react.useCallback)((0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        var ref, statistics;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    if (isAuthInit) {
                        _ctx.next = 2;
                        break;
                    }
                    return _ctx.abrupt("return");
                case 2:
                    _ctx.prev = 2;
                    ;
                    _ctx.next = 6;
                    return (0,livestream/* fetchStatisticsStream */.sb)(streamData === null || streamData === void 0 ? void 0 : streamData.id);
                case 6:
                    _ctx.t1 = ref = _ctx.sent;
                    _ctx.t0 = _ctx.t1 === null;
                    if (_ctx.t0) {
                        _ctx.next = 10;
                        break;
                    }
                    _ctx.t0 = ref === void 0;
                case 10:
                    if (!_ctx.t0) {
                        _ctx.next = 14;
                        break;
                    }
                    _ctx.t2 = void 0;
                    _ctx.next = 15;
                    break;
                case 14:
                    _ctx.t2 = ref.data;
                case 15:
                    statistics = _ctx.t2;
                    setViewerCount(statistics === null || statistics === void 0 ? void 0 : statistics.current_viewer_count);
                    if (currentAuth) {
                        _ctx.next = 19;
                        break;
                    }
                    return _ctx.abrupt("return");
                case 19:
                    if (!isStreaming && statistics.status === api/* LiveStreamStatus.InLive */.zN.InLive && statistics.delivery_started_at) {
                        setTimeout(function() {
                            refetchPost();
                        }, 5000);
                    }
                    _ctx.next = 24;
                    break;
                case 22:
                    _ctx.prev = 22;
                    _ctx.t3 = _ctx["catch"](2);
                case 24:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                2,
                22
            ]
        ]);
    })), [
        isAuthInit,
        streamData === null || streamData === void 0 ? void 0 : streamData.id,
        currentAuth,
        isStreaming,
        refetchPost
    ]);
    (0,react.useEffect)(function() {
        if (!fetchStreamData || !(streamData === null || streamData === void 0 ? void 0 : streamData.id) || !isPostDetail) return;
        if (viewerCount === 0) {
            void fetchStreamData();
        }
        var fetchStatistics = setInterval(function() {
            void fetchStreamData();
        }, utils/* STREAM_STATISTICS_INTERVAL */.Bw);
        return function() {
            return clearInterval(fetchStatistics);
        };
    }, [
        fetchStreamData,
        isStreaming,
        viewerCount,
        streamData === null || streamData === void 0 ? void 0 : streamData.id,
        isPostDetail,
        isContentLocked, 
    ]);
    // waiting backend
    var thumbnailShow = (0,react.useMemo)(function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (MediaContent_module_default()).liveStreamThumbnail,
            onClick: function(e) {
                var ref, ref1;
                e.preventDefault();
                if (beforeLiveRef === null || beforeLiveRef === void 0 ? void 0 : (ref = beforeLiveRef.current) === null || ref === void 0 ? void 0 : ref.contains(e.target)) return;
                var postDetailsUrl = "/".concat((ref1 = localPost.user_info) === null || ref1 === void 0 ? void 0 : ref1.username, "/posts/").concat(localPost.id);
                if (!isPostDetail) {
                    (0,post/* addClickPostEvent */.lR)({
                        postId: localPost.id,
                        screen: (0,pp_tracking/* parentKeyToScreenName */.lF)(parent),
                        postSource: localPost.source,
                        clickPosition: "media_view",
                        postType: localPost.type,
                        mediaType: api/* MediaType.Stream */.DD.Stream
                    });
                    void router.push(postDetailsUrl);
                    return;
                }
                if (!currentAuth) {
                    showLogin({
                        redirectUrl: postDetailsUrl
                    });
                    return;
                }
                if (isContentLocked && localPost.type === api/* PostType.Gold */.hQ.Gold && !(0,membership/* isGoldMember */.Ic)(currentUser)) {
                    setShowMembershipPayDialog({
                        open: true,
                        showMembershipStatus: false,
                        initPackage: api/* MembershipPackageName.Platinum */.uh.Platinum,
                        screen: pp_tracking/* ScreenName.PostDetail */.CG.PostDetail
                    });
                    return;
                }
                if (isPostDetail && isContentLocked && (0,post/* checkIsCreatorPaidPost */.b8)(localPost.type)) {
                    if (localPost.user_info.is_open_for_subscription === false) {
                        setSnackbarMessage({
                            type: "error",
                            text: (0,post/* exCreatorPostLockMessage */.e8)(localPost.type)
                        });
                        return;
                    }
                    showPaymentDialog({
                        creator: localPost.user_info
                    });
                    return;
                }
            },
            children: [
                isStreaming && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (MediaContent_module_default()).mediaControlBtn,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.ZP, {
                        name: "play",
                        width: 96,
                        height: 96
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    loading: "lazy",
                    src: streamData === null || streamData === void 0 ? void 0 : streamData.thumbnail,
                    alt: (0,post/* altImageOfPost */.Oq)(localPost.text),
                    onLoad: function(e) {
                        var target = e.target;
                        if (!target) return;
                        if (target.naturalHeight > target.naturalWidth / 1.2) {
                            setIsScale(true);
                        }
                    },
                    onError: function() {
                        return (0,utils/* loadImageHandleError */.In)(streamData === null || streamData === void 0 ? void 0 : streamData.thumbnail, linkThumbnailRef, function() {
                            linkThumbnailRef.current.style.display = "none";
                            setNoThumbnail(true);
                        });
                    }
                }),
                isStreaming && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (MediaContent_module_default()).streamInfo,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (MediaContent_module_default()).streamLabel,
                        children: "LIVE"
                    })
                })
            ]
        });
    }, [
        isStreaming,
        streamData === null || streamData === void 0 ? void 0 : streamData.thumbnail,
        localPost.user_info,
        localPost.id,
        localPost.type,
        localPost.source,
        localPost.text,
        isPostDetail,
        currentAuth,
        isContentLocked,
        currentUser,
        parent,
        router,
        showLogin,
        setShowMembershipPayDialog,
        showPaymentDialog,
        setSnackbarMessage, 
    ]);
    var ref5 = (0,es.useQuery)([
        "getLiveStreamToken",
        localPost.id.toString()
    ], (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        var ref;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    ;
                    return _ctx.abrupt("return", (0,livestream/* getStreamToken */.fo)((ref = localPost.streaming) === null || ref === void 0 ? void 0 : ref.id));
                case 2:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    })), {
        enabled: isAuthInit && !!currentAuth && isStreaming,
        refetchOnWindowFocus: false
    }), tokenData = ref5.data;
    if (!streamData) return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    if (!localPost.user_info) return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    var token = (streamData === null || streamData === void 0 ? void 0 : streamData.token) || (tokenData === null || tokenData === void 0 ? void 0 : (ref = tokenData.data) === null || ref === void 0 ? void 0 : ref.token) || "";
    var _obj;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: classnames_default()((MediaContent_module_default()).mediaWrapper, (MediaContent_module_default()).isStreaming, (_obj = {}, (0,_define_property/* default */.Z)(_obj, (MediaContent_module_default()).linkMediaNoThumbnail, noThumbnail), (0,_define_property/* default */.Z)(_obj, (MediaContent_module_default()).scaleMaxHeight, isScale && showingThumbnail), _obj)),
                children: showingThumbnail || !token || isPostDetail && !loadedPostWithAuth ? thumbnailShow : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (MediaContent_module_default()).videoWrapper,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LiveStreamPlayer, {
                        id: localPost.id,
                        disableAutoPlayOnFocus: isPostDetail,
                        startPosition: (streamData === null || streamData === void 0 ? void 0 : streamData.dvr_start_position) || 0,
                        viewerCount: isPostDetail ? viewerCount : streamData === null || streamData === void 0 ? void 0 : (ref1 = streamData.statistic) === null || ref1 === void 0 ? void 0 : ref1.current_viewer_count,
                        streamId: streamData === null || streamData === void 0 ? void 0 : streamData.id,
                        url: "".concat(streamData === null || streamData === void 0 ? void 0 : streamData.path_hls, "?token=").concat(token, "&start=").concat(new Date(streamData === null || streamData === void 0 ? void 0 : streamData.delivery_started_at).getTime()),
                        isLive: true,
                        startedAt: streamData === null || streamData === void 0 ? void 0 : streamData.delivery_started_at,
                        canSeeFreeMinutes: canSeeFreeMinutes,
                        freeMinutes: localPost === null || localPost === void 0 ? void 0 : localPost.free_minutes,
                        thumbnail: streamData === null || streamData === void 0 ? void 0 : streamData.thumbnail,
                        postAuthor: localPost.user_info,
                        isLocked: isContentLocked && !canSeeFreeMinutes,
                        isPostDetail: isPostDetail,
                        autoplayOnMount: isPostDetail,
                        handleStopFreeTimes: handleStopFreeTimes,
                        postType: localPost.type
                    })
                })
            }),
            (showingThumbnail || !token) && !isStreaming && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (MediaContent_module_default()).beforeLiveWrapper,
                ref: beforeLiveRef,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.ZP, {
                        name: "loading-spinner",
                        width: 44,
                        height: 44
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (MediaContent_module_default()).timeWrapper,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (MediaContent_module_default()).text,
                                children: new Date(planStartTime) >= new Date() ? "LIVE開始まで\n                ".concat((0,utils/* timeUntilMinutes */.g_)(new Date(planStartTime), api/* Language.Ja */.SQ.Ja)) : "LIVE開始を待っています"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (MediaContent_module_default()).time,
                                children: (0,dayjs/* default */.Z)(planStartTime).format("開始予定時間 MM月DD日 HH:mm")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RegistryNotification, {
                            user: localPost.user_info
                        })
                    })
                ]
            })
        ]
    });
};
var MediaLiveStreamCreator = function(param) {
    var localPost = param.localPost, _isLive = param.isLive, isLive = _isLive === void 0 ? true : _isLive;
    var ref, ref1;
    var isAuthInit = (0,global/* default */.Z)(function(state) {
        return state.isAuthInit;
    });
    var currentAuth = (0,global/* default */.Z)(function(state) {
        return state.currentAuth;
    });
    var streamData = localPost.streaming;
    var ref2 = (0,react.useState)(false), isScale = ref2[0], setIsScale = ref2[1];
    var isStreaming = (streamData === null || streamData === void 0 ? void 0 : streamData.status) === api/* LiveStreamStatus.InLive */.zN.InLive && !!(streamData === null || streamData === void 0 ? void 0 : streamData.path_hls);
    var ref3 = (0,es.useQuery)([
        "getLiveStreamToken",
        localPost.id.toString()
    ], (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        var ref;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    ;
                    return _ctx.abrupt("return", (0,livestream/* getStreamToken */.fo)((ref = localPost.streaming) === null || ref === void 0 ? void 0 : ref.id));
                case 2:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    })), {
        enabled: isAuthInit && !!currentAuth,
        refetchOnWindowFocus: false
    }), tokenData = ref3.data, refetchToken = ref3.refetch;
    var ref4 = (0,react.useState)(0), viewerCount = ref4[0], setViewerCount = ref4[1];
    var planStartTime = (streamData === null || streamData === void 0 ? void 0 : streamData.planned_to_start_at) || new Date().toISOString();
    var fetchStreamData = (0,react.useCallback)((0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        var ref, statistics;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    ;
                    _ctx.next = 4;
                    return (0,livestream/* fetchStatisticsStream */.sb)(streamData === null || streamData === void 0 ? void 0 : streamData.id);
                case 4:
                    _ctx.t1 = ref = _ctx.sent;
                    _ctx.t0 = _ctx.t1 === null;
                    if (_ctx.t0) {
                        _ctx.next = 8;
                        break;
                    }
                    _ctx.t0 = ref === void 0;
                case 8:
                    if (!_ctx.t0) {
                        _ctx.next = 12;
                        break;
                    }
                    _ctx.t2 = void 0;
                    _ctx.next = 13;
                    break;
                case 12:
                    _ctx.t2 = ref.data;
                case 13:
                    statistics = _ctx.t2;
                    setViewerCount(statistics === null || statistics === void 0 ? void 0 : statistics.current_viewer_count);
                    _ctx.next = 19;
                    break;
                case 17:
                    _ctx.prev = 17;
                    _ctx.t3 = _ctx["catch"](0);
                case 19:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                17
            ]
        ]);
    })), [
        streamData === null || streamData === void 0 ? void 0 : streamData.id
    ]);
    (0,react.useEffect)(function() {
        if (!isStreaming || !fetchStreamData || !(streamData === null || streamData === void 0 ? void 0 : streamData.id)) return;
        if (viewerCount === 0) {
            void fetchStreamData();
        }
        var fetchStatistics = setInterval(function() {
            void fetchStreamData();
        }, utils/* STREAM_STATISTICS_INTERVAL */.Bw);
        return function() {
            return clearInterval(fetchStatistics);
        };
    }, [
        fetchStreamData,
        isStreaming,
        viewerCount,
        streamData === null || streamData === void 0 ? void 0 : streamData.id
    ]);
    // waiting backend
    var thumbnailShow = (0,react.useMemo)(function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (MediaContent_module_default()).liveStreamThumbnail,
            children: [
                isStreaming && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (MediaContent_module_default()).mediaControlBtn,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.ZP, {
                        name: "play",
                        width: 96,
                        height: 96
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    loading: "lazy",
                    src: streamData === null || streamData === void 0 ? void 0 : streamData.thumbnail,
                    alt: "thumbnail",
                    onLoad: function(e) {
                        var target = e.target;
                        if (!target) return;
                        if (target.naturalHeight > target.naturalWidth / 1.2) {
                            setIsScale(true);
                        }
                    }
                }),
                isStreaming && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (MediaContent_module_default()).streamInfo,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (MediaContent_module_default()).streamLabel,
                        children: "LIVE"
                    })
                }),
                !isStreaming && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (MediaContent_module_default()).beforeLiveLabel,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.ZP, {
                            name: "loading-spinner",
                            width: 44,
                            height: 44
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (MediaContent_module_default()).timeWrapper,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (MediaContent_module_default()).text,
                                    children: new Date(planStartTime) >= new Date() ? "LIVE開始まで\n                ".concat((0,utils/* timeUntilMinutes */.g_)(new Date(planStartTime), api/* Language.Ja */.SQ.Ja)) : "LIVE開始を待っています"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (MediaContent_module_default()).time,
                                    children: (0,dayjs/* default */.Z)(planStartTime).format("開始予定時間 MM月DD日 HH:mm")
                                })
                            ]
                        })
                    ]
                })
            ]
        });
    }, [
        isStreaming,
        planStartTime,
        streamData === null || streamData === void 0 ? void 0 : streamData.thumbnail
    ]);
    if (!streamData) return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    if (!localPost.user_info) return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    var token = (streamData === null || streamData === void 0 ? void 0 : streamData.token) || (tokenData === null || tokenData === void 0 ? void 0 : (ref = tokenData.data) === null || ref === void 0 ? void 0 : ref.token) || "";
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (MediaContent_module_default()).mediaHeader,
        style: {
            width: "100%"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: classnames_default()((MediaContent_module_default()).mediaWrapper, (0,_define_property/* default */.Z)({}, (MediaContent_module_default()).scaleMaxHeight, isScale)),
            children: !isStreaming || !token ? thumbnailShow : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (MediaContent_module_default()).videoWrapper,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LiveStreamPlayer, {
                    id: localPost.id,
                    streamId: streamData === null || streamData === void 0 ? void 0 : streamData.id,
                    disableAutoPlayOnFocus: true,
                    startPosition: (streamData === null || streamData === void 0 ? void 0 : streamData.dvr_start_position) || 0,
                    viewerCount: viewerCount,
                    url: "".concat((ref1 = localPost.streaming) === null || ref1 === void 0 ? void 0 : ref1.path_hls, "?token=").concat(token),
                    isLive: isLive,
                    startedAt: isLive ? (streamData === null || streamData === void 0 ? void 0 : streamData.delivery_started_at) || (streamData === null || streamData === void 0 ? void 0 : streamData.started_at) : streamData === null || streamData === void 0 ? void 0 : streamData.started_at,
                    thumbnail: streamData === null || streamData === void 0 ? void 0 : streamData.thumbnail,
                    postAuthor: localPost.user_info,
                    isLiveStreamDetail: true,
                    isLocked: false,
                    isPostDetail: false,
                    autoplayOnMount: true,
                    refetchToken: refetchToken,
                    postType: localPost.type
                })
            })
        })
    });
};
/* harmony default export */ var components_MediaContent = (MediaContent);


/***/ }),

/***/ 77041:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ BigButton; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(14924);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(93967);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var components_common_Icon__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(37975);
/* harmony import */ var _Button_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1155);
/* harmony import */ var _Button_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_Button_module_scss__WEBPACK_IMPORTED_MODULE_3__);





function BigButton(param) {
    var onClick = param.onClick, text = param.text, _disabled = param.disabled, disabled = _disabled === void 0 ? false : _disabled, icon = param.icon, _alternateColor = param.alternateColor, alternateColor = _alternateColor === void 0 ? false : _alternateColor, _alternateColorFaded = param.alternateColorFaded, alternateColorFaded = _alternateColorFaded === void 0 ? false : _alternateColorFaded, _alternateColorWarning = param.alternateColorWarning, alternateColorWarning = _alternateColorWarning === void 0 ? false : _alternateColorWarning, _darkOrange = param.darkOrange, darkOrange = _darkOrange === void 0 ? false : _darkOrange, _pink = param.pink, pink = _pink === void 0 ? false : _pink, _hasOn = param.hasOn, hasOn = _hasOn === void 0 ? false : _hasOn, _fadeColorWhenOn = param.fadeColorWhenOn, fadeColorWhenOn = _fadeColorWhenOn === void 0 ? false : _fadeColorWhenOn, isOn = param.isOn, onText = param.onText, _blackAndWhite = param.blackAndWhite, blackAndWhite = _blackAndWhite === void 0 ? false : _blackAndWhite, _smallIcon = param.smallIcon, smallIcon = _smallIcon === void 0 ? false : _smallIcon, _verticalPadding = param.verticalPadding, verticalPadding = _verticalPadding === void 0 ? 6 : _verticalPadding, _horizontalPadding = param.horizontalPadding, horizontalPadding = _horizontalPadding === void 0 ? 18 : _horizontalPadding, _isLoading = param.isLoading, isLoading = _isLoading === void 0 ? false : _isLoading, _rounded = param.rounded, rounded = _rounded === void 0 ? false : _rounded, _fullWidth = param.fullWidth, fullWidth = _fullWidth === void 0 ? false : _fullWidth, _fadingStyle = param.fadingStyle, fadingStyle = _fadingStyle === void 0 ? false : _fadingStyle, _bigGuyStyle = param.bigGuyStyle, bigGuyStyle = _bigGuyStyle === void 0 ? false : _bigGuyStyle, _subText = param.subText, subText = _subText === void 0 ? "" : _subText, _colorName = param.colorName, colorName = _colorName === void 0 ? null : _colorName;
    // take into account black and white mode's border
    // so that a button's height is consistent
    var iconSize = smallIcon ? 18 : 32;
    var _obj;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
        className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_Button_module_scss__WEBPACK_IMPORTED_MODULE_3___default().button), (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_obj, (_Button_module_scss__WEBPACK_IMPORTED_MODULE_3___default().disabled), disabled), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_obj, (_Button_module_scss__WEBPACK_IMPORTED_MODULE_3___default().alternateColor), alternateColor), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_obj, (_Button_module_scss__WEBPACK_IMPORTED_MODULE_3___default().alternateColorFaded), alternateColorFaded), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_obj, (_Button_module_scss__WEBPACK_IMPORTED_MODULE_3___default().alternateColorWarning), alternateColorWarning), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_obj, (_Button_module_scss__WEBPACK_IMPORTED_MODULE_3___default().darkOrange), darkOrange), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_obj, (_Button_module_scss__WEBPACK_IMPORTED_MODULE_3___default().pink), pink), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_obj, (_Button_module_scss__WEBPACK_IMPORTED_MODULE_3___default().hasIcon), !!icon), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_obj, (_Button_module_scss__WEBPACK_IMPORTED_MODULE_3___default().blackAndWhite), blackAndWhite), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_obj, (_Button_module_scss__WEBPACK_IMPORTED_MODULE_3___default().faded), fadeColorWhenOn && isOn), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_obj, (_Button_module_scss__WEBPACK_IMPORTED_MODULE_3___default().rounded), rounded), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_obj, (_Button_module_scss__WEBPACK_IMPORTED_MODULE_3___default().loading), isLoading), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_obj, (_Button_module_scss__WEBPACK_IMPORTED_MODULE_3___default().fullWidth), fullWidth), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_obj, (_Button_module_scss__WEBPACK_IMPORTED_MODULE_3___default().fadingStyle), fadingStyle), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_obj, (_Button_module_scss__WEBPACK_IMPORTED_MODULE_3___default().bigGuyStyle), bigGuyStyle), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_obj, (_Button_module_scss__WEBPACK_IMPORTED_MODULE_3___default().hasSubText), !!subText), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_obj, (_Button_module_scss__WEBPACK_IMPORTED_MODULE_3___default())[colorName], !!colorName), _obj)),
        disabled: disabled || isLoading,
        onClick: onClick,
        style: !subText ? {
            padding: "".concat(verticalPadding, "px ").concat(horizontalPadding, "px")
        } : {},
        children: isLoading ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_common_Icon__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP, {
            name: "loading-anim-2",
            width: 24,
            height: 24
        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: (_Button_module_scss__WEBPACK_IMPORTED_MODULE_3___default().main),
                    style: subText ? {
                        padding: "".concat(verticalPadding, "px ").concat(horizontalPadding, "px")
                    } : {},
                    children: [
                        icon && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: (_Button_module_scss__WEBPACK_IMPORTED_MODULE_3___default().icon),
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_common_Icon__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP, {
                                name: icon,
                                width: iconSize,
                                height: iconSize,
                                hasOn: hasOn,
                                isOn: isOn
                            })
                        }),
                        hasOn && isOn ? onText : text
                    ]
                }),
                subText && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                    className: (_Button_module_scss__WEBPACK_IMPORTED_MODULE_3___default().subText),
                    children: subText
                })
            ]
        })
    });
};


/***/ }),

/***/ 64739:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(14924);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(93967);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var common_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(22467);
/* harmony import */ var common_utils_membership__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(77063);
/* harmony import */ var components_common_Icon__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(37975);
/* harmony import */ var store_timeline__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(12800);
/* harmony import */ var store_global__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(8405);
/* harmony import */ var _PlayerRateOptions_module_scss__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(93213);
/* harmony import */ var _PlayerRateOptions_module_scss__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_PlayerRateOptions_module_scss__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var common_utils_pp_tracking__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(67027);
/* harmony import */ var _amplitude_analytics_browser__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(38367);











// FIXME: change isWhite to isAudioPlayer
var PlayerRateOptions = function(param) {
    var setPlaybackRate = param.setPlaybackRate, _isWhite = param.isWhite, isWhite = _isWhite === void 0 ? false : _isWhite, clickCallback = param.clickCallback;
    var currentUser = (0,store_timeline__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP)(function(state) {
        return state.currentUser;
    });
    var setShowMembershipPayDialog = (0,store_global__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(function(state) {
        return state.setShowMembershipPayDialog;
    });
    var currentAuth = (0,store_global__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(function(state) {
        return state.currentAuth;
    });
    var showLogin = (0,store_global__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(function(state) {
        return state.showLogin;
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: common_utils__WEBPACK_IMPORTED_MODULE_2__/* .ALL_PLAYER_RATES.map */ .XH.map(function(rate, index) {
            var isVip = rate.isVip && !(0,common_utils_membership__WEBPACK_IMPORTED_MODULE_3__/* .canUseOption */ .Yg)(currentUser, rate.vipPackage);
            var _obj;
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                onClick: function() {
                    (0,_amplitude_analytics_browser__WEBPACK_IMPORTED_MODULE_8__/* .track */ .j)("Change ".concat(isWhite ? "Audio" : "Video", " Play Speed"));
                    (0,common_utils_pp_tracking__WEBPACK_IMPORTED_MODULE_7__/* .addEvent */ .vP)({
                        action: common_utils_pp_tracking__WEBPACK_IMPORTED_MODULE_7__/* .EventAction.Click */ .AO.Click,
                        category: common_utils_pp_tracking__WEBPACK_IMPORTED_MODULE_7__/* .EventCategory.Membership */ .Jk.Membership,
                        screen: common_utils_pp_tracking__WEBPACK_IMPORTED_MODULE_7__/* .ScreenName.PostDetail */ .CG.PostDetail,
                        component: isWhite ? common_utils_pp_tracking__WEBPACK_IMPORTED_MODULE_7__/* .EventComponent.AudioPlayer */ .Br.AudioPlayer : common_utils_pp_tracking__WEBPACK_IMPORTED_MODULE_7__/* .EventComponent.VideoPlayer */ .Br.VideoPlayer,
                        timestamp: new Date().toISOString(),
                        tracking_params: [
                            {
                                label: "speed_rate",
                                value: rate.rate.toString()
                            }, 
                        ]
                    });
                    if (isVip) {
                        if (!currentAuth) {
                            showLogin({});
                            return;
                        }
                        setShowMembershipPayDialog({
                            open: true,
                            showMembershipStatus: false,
                            initPackage: rate.vipPackage,
                            screen: common_utils_pp_tracking__WEBPACK_IMPORTED_MODULE_7__/* .ScreenName.PostDetail */ .CG.PostDetail
                        });
                        clickCallback && clickCallback();
                        return;
                    }
                    setPlaybackRate(rate.rate);
                },
                className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_PlayerRateOptions_module_scss__WEBPACK_IMPORTED_MODULE_9___default().text), (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(_obj, (_PlayerRateOptions_module_scss__WEBPACK_IMPORTED_MODULE_9___default().isVip), isVip), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(_obj, (_PlayerRateOptions_module_scss__WEBPACK_IMPORTED_MODULE_9___default().isMembership), (0,common_utils_membership__WEBPACK_IMPORTED_MODULE_3__/* .isGoldMember */ .Ic)(currentUser)), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(_obj, (_PlayerRateOptions_module_scss__WEBPACK_IMPORTED_MODULE_9___default().isWhite), isWhite), _obj)),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: (_PlayerRateOptions_module_scss__WEBPACK_IMPORTED_MODULE_9___default().content),
                        children: [
                            rate.rate,
                            "x"
                        ]
                    }),
                    isVip && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: (_PlayerRateOptions_module_scss__WEBPACK_IMPORTED_MODULE_9___default().icon),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_common_Icon__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP, {
                            name: "".concat(rate.vipPackage, "-vip-icon"),
                            height: 22,
                            width: 22
                        })
                    })
                ]
            }, "option-".concat(index));
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (PlayerRateOptions);


/***/ }),

/***/ 8325:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ ProgressRing; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(14924);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(93967);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _ProgressRing_module_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(88821);
/* harmony import */ var _ProgressRing_module_scss__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_ProgressRing_module_scss__WEBPACK_IMPORTED_MODULE_2__);




function ProgressRing(param) {
    var radius = param.radius, current = param.current, total = param.total;
    var stroke = 3;
    var normalizedRadius = radius - stroke * 2;
    var circumference = normalizedRadius * 2 * Math.PI;
    var progress = current > total ? 1 : current / total;
    var strokeDashoffset = circumference - progress * circumference;
    var strokeColor = current <= total ? "#0abc71" : "#e54040";
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: (_ProgressRing_module_scss__WEBPACK_IMPORTED_MODULE_2___default().ring),
        style: {
            width: radius * 2,
            height: radius * 2
        },
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_ProgressRing_module_scss__WEBPACK_IMPORTED_MODULE_2___default().text), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, (_ProgressRing_module_scss__WEBPACK_IMPORTED_MODULE_2___default().overflow), current > total)),
                children: total - current
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
                height: radius * 2,
                width: radius * 2,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", {
                        stroke: "#cccccc",
                        fill: "transparent",
                        strokeWidth: stroke,
                        r: normalizedRadius,
                        cx: radius,
                        cy: radius
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", {
                        stroke: strokeColor,
                        fill: "transparent",
                        strokeWidth: stroke,
                        strokeDasharray: "".concat(circumference, " ").concat(circumference),
                        style: {
                            strokeDashoffset: strokeDashoffset
                        },
                        r: normalizedRadius,
                        cx: radius,
                        cy: radius
                    })
                ]
            })
        ]
    });
};


/***/ }),

/***/ 8348:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ RichContent; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(93967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./common/utils/index.ts + 1 modules
var utils = __webpack_require__(22467);
;// CONCATENATED MODULE: ./common/utils/escapeHtml.ts
function escapeHtml(unsafe) {
    return unsafe.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;");
};

// EXTERNAL MODULE: ./components/common/RichContent/RichContent.module.scss
var RichContent_module = __webpack_require__(54681);
var RichContent_module_default = /*#__PURE__*/__webpack_require__.n(RichContent_module);
;// CONCATENATED MODULE: ./components/common/RichContent/index.tsx






var specialRegex = /&lt;span style=&quot;background:#FFFF00; color:#000; padding:3px;&quot;&gt;(.+)&lt;\/span&gt;/g;
var hashtagRegex = (0,utils/* hashTagRegexFactoryWithSpace */._y)();
var linkRegex = (0,utils/* linkRegexFactory */.EU)();
var emailReplacer = function(match) {
    return '<span class="'.concat((RichContent_module_default()).email, '"><a target="_blank" rel="noopener noreferrer" href="mailto: ').concat(match, '">').concat(match, "</a></span>");
};
var linkReplacer = function(match) {
    if (utils/* VALID_EMAIL_REGEX.test */.Fh.test(match)) return emailReplacer(match);
    var href = "//".concat(match);
    if (match.startsWith("http") || match.startsWith("https")) {
        href = match;
    }
    return '<a href="'.concat((0,utils/* externalUrlRedirectLink */.tO)(href), '" class="').concat((RichContent_module_default()).link, '" target="_blank" rel="noopener noreferrer" onClick="(e) => e.stopPropagation()">').concat(match, "</a>");
};
var hashTagReplacer = function(match) {
    var startCharacter = match.substring(0, 1);
    var isStartOfLine = !startCharacter.match(/\s/);
    var showString = isStartOfLine ? match : match.substring(1);
    return "".concat(isStartOfLine ? "" : startCharacter, '<span class="').concat((RichContent_module_default()).hashtag, '"><a target="_blank" rel="noopener noreferrer" href="/topics/').concat(showString.substring(1), '">').concat(showString, "</a></span>");
};
function RichContent(param) {
    var text = param.text, _specialEscape = param.specialEscape, specialEscape = _specialEscape === void 0 ? false : _specialEscape, _mentionTargets = param.mentionTargets, mentionTargets = _mentionTargets === void 0 ? [] : _mentionTargets;
    var escapedText = (0,react.useMemo)(function() {
        var escaped = escapeHtml(text || "");
        if (specialEscape) {
            escaped = escaped.replace(specialRegex, '<span class="'.concat((RichContent_module_default()).special, '">$1</span>'));
        }
        escaped = escaped.replace(hashtagRegex, hashTagReplacer);
        // because of &#39; has #, should replace after check hash
        escaped = escaped.replace(/'/g, "&#39;");
        mentionTargets.forEach(function(mention) {
            escaped = escaped.replace("@".concat(mention.id), '<a target="_blank" onClick="(e) => e.stopPropagation()" href="/'.concat(mention.username, '" class="').concat((RichContent_module_default()).mention, '">@').concat(mention.name, "</a>"));
        });
        escaped = escaped.replace(linkRegex, linkReplacer);
        return escaped;
    }, [
        text,
        specialEscape,
        mentionTargets
    ]);
    // prevent onClick event when clicking on a link
    var handleClick = function(e) {
        var target = e.target;
        if (target.tagName.toLowerCase() === "a") {
            e.stopPropagation();
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        onClick: handleClick,
        className: classnames_default()((RichContent_module_default()).richContentWrapper, "richcontent"),
        dangerouslySetInnerHTML: {
            __html: escapedText
        }
    });
};


/***/ }),

/***/ 55646:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ common_TextEditor; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/draft-js/lib/Draft.js
var Draft = __webpack_require__(9041);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./common/utils/index.ts + 1 modules
var utils = __webpack_require__(22467);
// EXTERNAL MODULE: ./node_modules/draft-js/dist/Draft.css
var dist_Draft = __webpack_require__(40080);
// EXTERNAL MODULE: ./components/common/TextEditor/TextEditor.module.scss
var TextEditor_module = __webpack_require__(21086);
var TextEditor_module_default = /*#__PURE__*/__webpack_require__.n(TextEditor_module);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(88029);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs + 3 modules
var _create_super = __webpack_require__(76166);
;// CONCATENATED MODULE: ./common/utils/ErrorBoundaryClient/index.tsx




var ErrorBoundaryWithHandler = /*#__PURE__*/ function(Component) {
    "use strict";
    (0,_inherits/* default */.Z)(ErrorBoundaryWithHandler, Component);
    var _super = (0,_create_super/* default */.Z)(ErrorBoundaryWithHandler);
    function ErrorBoundaryWithHandler() {
        (0,_class_call_check/* default */.Z)(this, ErrorBoundaryWithHandler);
        return _super.apply(this, arguments);
    }
    var _proto = ErrorBoundaryWithHandler.prototype;
    _proto.componentDidCatch = function componentDidCatch(error, errorInfo) {
        console.error("Uncaught error:", error, errorInfo);
        this.props.errorHandler();
        this.forceUpdate();
    };
    _proto.render = function render() {
        return this.props.children;
    };
    return ErrorBoundaryWithHandler;
}(react.Component);
/* harmony default export */ var ErrorBoundaryClient = (ErrorBoundaryWithHandler);

;// CONCATENATED MODULE: ./components/common/TextEditor/index.tsx
/* eslint-disable @typescript-eslint/no-unsafe-member-access */ /* eslint-disable @typescript-eslint/no-unsafe-assignment */ 








function findWithRegex(regex, contentBlock, callback) {
    var text = contentBlock.getText();
    var matchArr;
    var start;
    while((matchArr = regex.exec(text)) !== null){
        start = matchArr.index;
        callback(start, start + matchArr[0].length);
    }
}
var mentionSpan = function(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
        className: (TextEditor_module_default()).mention,
        children: children
    });
};
var hashtagSpan = function(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
        className: (TextEditor_module_default()).hashtag,
        children: children
    });
};
var OverLimitSpan = function(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
        className: (TextEditor_module_default()).overLimit,
        children: children
    });
};
var hashtagRegedx = (0,utils/* hashTagRegexFactory */.cS)();
var linkRegex = (0,utils/* linkRegexFactory */.EU)();
function hashtagStrategy(contentBlock, callback) {
    findWithRegex(hashtagRegedx, contentBlock, callback);
}
function linkStrategy(contentBlock, callback) {
    findWithRegex(linkRegex, contentBlock, callback);
}
var TextEditor = function(param, ref) {
    var setPlainText = param.setPlainText, placeholder = param.placeholder, onFocus = param.onFocus, readOnly = param.readOnly, _initialText = param.initialText, initialText = _initialText === void 0 ? "" : _initialText, _charLimit = param.charLimit, charLimit = _charLimit === void 0 ? 2000 : _charLimit, mentionTarget = param.mentionTarget, _textPolicies = param.textPolicies, textPolicies = _textPolicies === void 0 ? [] : _textPolicies, _blackUrls = param.blackUrls, blackUrls = _blackUrls === void 0 ? [] : _blackUrls, onEnter = param.onEnter;
    var overLimitStrategy = (0,react.useMemo)(function() {
        return function(contentBlock, callback) {
            var text = contentBlock.getText();
            var len = text.length;
            if (len > charLimit) {
                callback(charLimit, len);
            }
        };
    }, [
        charLimit
    ]);
    var mentionStrategy = (0,react.useMemo)(function() {
        return function(contentBlock, callback) {
            if (!mentionTarget) return;
            var text = contentBlock.getText();
            try {
                var regex = new RegExp("@".concat(mentionTarget.name).replaceAll("(", "\\(").replaceAll(")", "\\)").replaceAll("[", "\\[").replaceAll("*", "\\*").replaceAll("+", "\\+"));
                var matchArr = regex.exec(text);
                if (matchArr !== null) {
                    var start = matchArr.index;
                    callback(start, start + matchArr[0].length);
                }
            // eslint-disable-next-line no-empty
            } catch (e) {}
        };
    }, [
        mentionTarget
    ]);
    var policyStrategy = (0,react.useMemo)(function() {
        return function(contentBlock, callback) {
            if (!textPolicies || textPolicies.length === 0) return;
            var text = contentBlock.getText();
            try {
                textPolicies.forEach(function(policy) {
                    var regex = new RegExp(policy.name);
                    var matchArr = regex.exec(text);
                    if (matchArr !== null) {
                        var start = matchArr.index;
                        callback(start, start + matchArr[0].length);
                    }
                });
            // eslint-disable-next-line no-empty
            } catch (e) {}
        };
    }, [
        textPolicies
    ]);
    var policySpan = (0,react.useCallback)(function(data) {
        var children = data.children;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
            className: (TextEditor_module_default()).policy,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("del", {
                children: children
            })
        });
    }, []);
    var linkSpan = (0,react.useCallback)(function(data) {
        var children = data.children;
        if (!blackUrls || blackUrls.length === 0) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: (TextEditor_module_default()).link,
                children: children
            });
        }
        var text = data.decoratedText;
        var blackUrl = blackUrls.find(function(u) {
            return u.url.includes(text);
        });
        if (!blackUrl) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: (TextEditor_module_default()).link,
                children: children
            });
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
            className: (TextEditor_module_default()).policy,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("del", {
                children: children
            })
        });
    }, [
        blackUrls
    ]);
    var decorator = (0,react.useMemo)(function() {
        return new Draft.CompositeDecorator([
            {
                strategy: overLimitStrategy,
                component: OverLimitSpan
            },
            {
                strategy: linkStrategy,
                component: linkSpan
            },
            {
                strategy: mentionStrategy,
                component: mentionSpan
            },
            {
                strategy: policyStrategy,
                component: policySpan
            },
            {
                strategy: hashtagStrategy,
                component: hashtagSpan
            }, 
        ]);
    }, [
        overLimitStrategy,
        linkSpan,
        mentionStrategy,
        policyStrategy,
        policySpan
    ]);
    var _$ref = (0,react.useState)(function() {
        return Draft.EditorState.createWithContent(Draft.ContentState.createFromText(initialText), decorator);
    }), editorState = _$ref[0], setEditorState = _$ref[1];
    var selfRef = (0,react.useRef)();
    (0,react.useImperativeHandle)(ref, function() {
        return {
            getContent: function getContent() {
                return editorState.getCurrentContent().getPlainText("");
            },
            setEditorText: function(s) {
                var state = Draft.EditorState.set(Draft.EditorState.createWithContent(Draft.ContentState.createFromText(s)), {
                    decorator: decorator
                });
                setEditorState(state);
            },
            focus: function focus() {
                setEditorState(Draft.EditorState.moveFocusToEnd(editorState));
            },
            reset: function reset() {
                var newState = Draft.EditorState.createEmpty();
                setEditorState(Draft.EditorState.moveFocusToEnd(newState));
            },
            forceRender: function forceRender() {
                var content = editorState.getCurrentContent();
                var currentOffset = editorState.getSelection().getFocusOffset();
                var newEditorState = Draft.EditorState.createWithContent(content, decorator);
                var newSelection = editorState.getSelection().merge({
                    focusOffset: currentOffset,
                    anchorOffset: currentOffset
                });
                setEditorState(Draft.EditorState.acceptSelection(newEditorState, newSelection));
            }
        };
    }, [
        editorState,
        decorator
    ]);
    (0,react.useEffect)(function() {
        var plainText = editorState.getCurrentContent().getPlainText("");
        setPlainText(plainText);
    }, [
        setPlainText,
        editorState
    ]);
    var handleBeforeInput = function(chars, state) {
        try {
            var currentContentState = state.getCurrentContent();
            var selectionState = state.getSelection();
            setEditorState(Draft.EditorState.push(editorState, Draft.Modifier.replaceText(currentContentState, selectionState, chars), "remove-range"));
        // eslint-disable-next-line no-empty
        } catch (error) {}
        return "handled";
    };
    var handleKeyCommand = function(command) {
        if (command === "enter_command") {
            onEnter && onEnter();
            return "handled";
        }
        return "not-handled";
    };
    var myKeyBindingFn = function(e) {
        if (e.key === "Enter" && onEnter) {
            return "enter_command";
        }
        return (0,Draft.getDefaultKeyBinding)(e);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (TextEditor_module_default()).textEditorWrapper,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorBoundaryClient, {
            errorHandler: function() {
                var content = editorState.getCurrentContent();
                var currentOffset = editorState.getSelection().getFocusOffset();
                var newEditorState = Draft.EditorState.createWithContent(content, decorator);
                var newSelection = editorState.getSelection().merge({
                    focusOffset: currentOffset,
                    anchorOffset: currentOffset
                });
                setEditorState(Draft.EditorState.acceptSelection(newEditorState, newSelection));
            },
            children: editorState && /*#__PURE__*/ (0,jsx_runtime.jsx)(Draft.Editor, {
                ref: selfRef,
                editorState: editorState,
                onChange: setEditorState,
                placeholder: placeholder,
                spellCheck: true,
                handleKeyCommand: handleKeyCommand,
                keyBindingFn: myKeyBindingFn,
                onFocus: onFocus,
                readOnly: readOnly,
                handleBeforeInput: handleBeforeInput,
                handlePastedText: function(text) {
                    try {
                        var pastedBlocks = Draft.ContentState.createFromText(text).getBlockMap();
                        var newState = Draft.Modifier.replaceWithFragment(editorState.getCurrentContent(), editorState.getSelection(), pastedBlocks);
                        setEditorState(Draft.EditorState.push(editorState, newState, "insert-fragment"));
                    // eslint-disable-next-line no-empty
                    } catch (error) {}
                    return "handled";
                }
            })
        })
    });
};
// const policyLink = (text: string, url: string): string => {
//   const start = text.indexOf(`[`);
//   const end = text.indexOf(`]`);
//   const linkText = text.substring(start + 1, end);
//   return text.replace(
//     `[${linkText}]`,
//     `<a onclick="window.open('${url}')">${linkText}</a>`
//   );
// };
/* harmony default export */ var common_TextEditor = (/*#__PURE__*/(0,react.forwardRef)(TextEditor));


/***/ }),

/***/ 85631:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


var ViewedContent = function(param) {
    var children = param.children, firstViewCallback = param.firstViewCallback;
    var contentRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    var intersectionCb = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function(entries) {
        var target = entries[0];
        if (target && target.isIntersecting) {
            firstViewCallback();
        }
    }, [
        firstViewCallback
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (!contentRef.current) return;
        var ref = contentRef.current;
        var options = {
            root: null,
            rootMargin: "0px",
            threshold: 0.3
        };
        // Create observer
        var observer = new IntersectionObserver(intersectionCb, options);
        // observe the audio player
        if (ref) {
            observer.observe(ref);
        }
        // clean up on willUnMount
        return function() {
            if (ref) {
                observer.unobserve(ref);
            }
        };
    }, [
        intersectionCb
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        ref: contentRef,
        children: children
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ViewedContent);


/***/ }),

/***/ 82752:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E": function() { return /* binding */ adsTrackingCall; }
/* harmony export */ });
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(87066);

var adsTrackingCall = function(param) {
    var type = param.type, postId = param.postId, parentType = param.parentType;
    try {
        void axios__WEBPACK_IMPORTED_MODULE_0__/* ["default"].post */ .Z.post("/posts/".concat(postId, "/affiliate-interaction"), {
            interaction_type: type,
            client: "web",
            screen_log: parentType
        })// eslint-disable-next-line @typescript-eslint/no-empty-function
        .catch(function() {});
    // eslint-disable-next-line no-empty
    } catch (error) {}
};


/***/ }),

/***/ 83588:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C5": function() { return /* binding */ createStream; },
/* harmony export */   "Dt": function() { return /* binding */ getEndedStreams; },
/* harmony export */   "EW": function() { return /* binding */ getAllStreamKeys; },
/* harmony export */   "Us": function() { return /* binding */ createStreamKey; },
/* harmony export */   "WH": function() { return /* binding */ startStream; },
/* harmony export */   "d5": function() { return /* binding */ leaveStream; },
/* harmony export */   "fo": function() { return /* binding */ getStreamToken; },
/* harmony export */   "g": function() { return /* binding */ stopStream; },
/* harmony export */   "jI": function() { return /* binding */ updateStream; },
/* harmony export */   "lJ": function() { return /* binding */ fetchStreamsRemainingTime; },
/* harmony export */   "le": function() { return /* binding */ joinStream; },
/* harmony export */   "lp": function() { return /* binding */ getStreamInfoPromise; },
/* harmony export */   "r8": function() { return /* binding */ getStreamInfo; },
/* harmony export */   "sb": function() { return /* binding */ fetchStatisticsStream; },
/* harmony export */   "wq": function() { return /* binding */ updateStreamKey; },
/* harmony export */   "yk": function() { return /* binding */ getUpComingStreams; },
/* harmony export */   "yr": function() { return /* binding */ deleteStreamKey; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(47568);
/* harmony import */ var _home_circleci_project_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _home_circleci_project_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_home_circleci_project_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(87066);



var createStream = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_home_circleci_project_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(param) {
        var streamingKeyId, publishTime, thumbnail, videoSource;
        return _home_circleci_project_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    streamingKeyId = param.streamingKeyId, publishTime = param.publishTime, thumbnail = param.thumbnail, videoSource = param.videoSource;
                    _ctx.next = 3;
                    return axios__WEBPACK_IMPORTED_MODULE_2__/* ["default"].post */ .Z.post("/streamings/", {
                        streaming_key_id: streamingKeyId,
                        planned_to_start_at: publishTime,
                        video_source: String(videoSource),
                        thumbnail: thumbnail
                    });
                case 3:
                    return _ctx.abrupt("return", _ctx.sent.data);
                case 4:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function createStream(_) {
        return _ref.apply(this, arguments);
    };
}();
var updateStream = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_home_circleci_project_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(param) {
        var streamingKeyId, publishTime, thumbnail, videoSource, streamId;
        return _home_circleci_project_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    streamingKeyId = param.streamingKeyId, publishTime = param.publishTime, thumbnail = param.thumbnail, videoSource = param.videoSource, streamId = param.streamId;
                    _ctx.next = 3;
                    return axios__WEBPACK_IMPORTED_MODULE_2__/* ["default"].put */ .Z.put("/streamings/".concat(streamId), {
                        streaming_key_id: streamingKeyId,
                        planned_to_start_at: publishTime,
                        video_source: String(videoSource),
                        thumbnail: thumbnail
                    });
                case 3:
                    return _ctx.abrupt("return", _ctx.sent.data);
                case 4:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function updateStream(_) {
        return _ref.apply(this, arguments);
    };
}();
var getUpComingStreams = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_home_circleci_project_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(page) {
        return _home_circleci_project_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return axios__WEBPACK_IMPORTED_MODULE_2__/* ["default"].get */ .Z.get("/streamings/?statuses[]=before_live&statuses[]=in_live&page=".concat(page));
                case 2:
                    return _ctx.abrupt("return", _ctx.sent.data);
                case 3:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function getUpComingStreams(page) {
        return _ref.apply(this, arguments);
    };
}();
var getEndedStreams = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_home_circleci_project_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(page) {
        return _home_circleci_project_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return axios__WEBPACK_IMPORTED_MODULE_2__/* ["default"].get */ .Z.get("/streamings/?statuses[]=ended&page=".concat(page));
                case 2:
                    return _ctx.abrupt("return", _ctx.sent.data);
                case 3:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function getEndedStreams(page) {
        return _ref.apply(this, arguments);
    };
}();
var getStreamInfo = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_home_circleci_project_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(id) {
        return _home_circleci_project_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return axios__WEBPACK_IMPORTED_MODULE_2__/* ["default"].get */ .Z.get("/streamings/".concat(id));
                case 2:
                    return _ctx.abrupt("return", _ctx.sent.data);
                case 3:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function getStreamInfo(id) {
        return _ref.apply(this, arguments);
    };
}();
var getStreamInfoPromise = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_home_circleci_project_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(id) {
        return _home_circleci_project_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return axios__WEBPACK_IMPORTED_MODULE_2__/* ["default"].get */ .Z.get("/streamings/".concat(id));
                case 2:
                    return _ctx.abrupt("return", _ctx.sent);
                case 3:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function getStreamInfoPromise(id) {
        return _ref.apply(this, arguments);
    };
}();
var getStreamToken = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_home_circleci_project_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(streamId) {
        return _home_circleci_project_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return axios__WEBPACK_IMPORTED_MODULE_2__/* ["default"].get */ .Z.get("/streamings/".concat(streamId, "/token"));
                case 2:
                    return _ctx.abrupt("return", _ctx.sent.data);
                case 3:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function getStreamToken(streamId) {
        return _ref.apply(this, arguments);
    };
}();
var createStreamKey = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_home_circleci_project_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(param) {
        var keyName;
        return _home_circleci_project_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    keyName = param.keyName;
                    _ctx.next = 3;
                    return axios__WEBPACK_IMPORTED_MODULE_2__/* ["default"].post */ .Z.post("/streamings/keys/", {
                        name: keyName
                    });
                case 3:
                    return _ctx.abrupt("return", _ctx.sent.data);
                case 4:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function createStreamKey(_) {
        return _ref.apply(this, arguments);
    };
}();
var updateStreamKey = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_home_circleci_project_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(param) {
        var keyId, name, _isDefault, isDefault;
        return _home_circleci_project_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    keyId = param.keyId, name = param.name, _isDefault = param.isDefault, isDefault = _isDefault === void 0 ? false : _isDefault;
                    _ctx.next = 3;
                    return axios__WEBPACK_IMPORTED_MODULE_2__/* ["default"].put */ .Z.put("/streamings/keys/".concat(keyId), {
                        name: name,
                        default: isDefault
                    });
                case 3:
                    return _ctx.abrupt("return", _ctx.sent);
                case 4:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function updateStreamKey(_) {
        return _ref.apply(this, arguments);
    };
}();
var deleteStreamKey = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_home_circleci_project_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(param) {
        var keyId;
        return _home_circleci_project_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    keyId = param.keyId;
                    _ctx.next = 3;
                    return axios__WEBPACK_IMPORTED_MODULE_2__/* ["default"]["delete"] */ .Z["delete"]("/streamings/keys/".concat(keyId));
                case 3:
                    return _ctx.abrupt("return", _ctx.sent);
                case 4:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function deleteStreamKey(_) {
        return _ref.apply(this, arguments);
    };
}();
var getAllStreamKeys = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_home_circleci_project_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        return _home_circleci_project_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return axios__WEBPACK_IMPORTED_MODULE_2__/* ["default"].get */ .Z.get("/streamings/keys/");
                case 2:
                    return _ctx.abrupt("return", _ctx.sent.data);
                case 3:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function getAllStreamKeys() {
        return _ref.apply(this, arguments);
    };
}();
var startStream = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_home_circleci_project_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(id) {
        return _home_circleci_project_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return axios__WEBPACK_IMPORTED_MODULE_2__/* ["default"].post */ .Z.post("/streamings/".concat(id, "/start"));
                case 2:
                    return _ctx.abrupt("return", _ctx.sent);
                case 3:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function startStream(id) {
        return _ref.apply(this, arguments);
    };
}();
var stopStream = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_home_circleci_project_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(id) {
        return _home_circleci_project_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return axios__WEBPACK_IMPORTED_MODULE_2__/* ["default"].post */ .Z.post("/streamings/".concat(id, "/end"));
                case 2:
                    return _ctx.abrupt("return", _ctx.sent);
                case 3:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function stopStream(id) {
        return _ref.apply(this, arguments);
    };
}();
var joinStream = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_home_circleci_project_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(id) {
        return _home_circleci_project_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return axios__WEBPACK_IMPORTED_MODULE_2__/* ["default"].post */ .Z.post("/streamings/".concat(id, "/join"));
                case 3:
                    _ctx.next = 7;
                    break;
                case 5:
                    _ctx.prev = 5;
                    _ctx.t0 = _ctx["catch"](0);
                case 7:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                5
            ]
        ]);
    }));
    return function joinStream(id) {
        return _ref.apply(this, arguments);
    };
}();
var leaveStream = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_home_circleci_project_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(id) {
        return _home_circleci_project_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return axios__WEBPACK_IMPORTED_MODULE_2__/* ["default"].post */ .Z.post("/streamings/".concat(id, "/leave"));
                case 3:
                    _ctx.next = 7;
                    break;
                case 5:
                    _ctx.prev = 5;
                    _ctx.t0 = _ctx["catch"](0);
                case 7:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                5
            ]
        ]);
    }));
    return function leaveStream(id) {
        return _ref.apply(this, arguments);
    };
}();
var fetchStatisticsStream = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_home_circleci_project_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(id) {
        var ref;
        return _home_circleci_project_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    ;
                    _ctx.next = 3;
                    return axios__WEBPACK_IMPORTED_MODULE_2__/* ["default"].get */ .Z.get("/streamings/".concat(id, "/statistics"));
                case 3:
                    _ctx.t1 = ref = _ctx.sent;
                    _ctx.t0 = _ctx.t1 === null;
                    if (_ctx.t0) {
                        _ctx.next = 7;
                        break;
                    }
                    _ctx.t0 = ref === void 0;
                case 7:
                    if (!_ctx.t0) {
                        _ctx.next = 11;
                        break;
                    }
                    _ctx.t2 = void 0;
                    _ctx.next = 12;
                    break;
                case 11:
                    _ctx.t2 = ref.data;
                case 12:
                    return _ctx.abrupt("return", _ctx.t2);
                case 13:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function fetchStatisticsStream(id) {
        return _ref.apply(this, arguments);
    };
}();
var fetchStreamsRemainingTime = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_home_circleci_project_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        var ref;
        return _home_circleci_project_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    ;
                    _ctx.next = 3;
                    return axios__WEBPACK_IMPORTED_MODULE_2__/* ["default"].get */ .Z.get("/streamings/summary");
                case 3:
                    _ctx.t1 = ref = _ctx.sent;
                    _ctx.t0 = _ctx.t1 === null;
                    if (_ctx.t0) {
                        _ctx.next = 7;
                        break;
                    }
                    _ctx.t0 = ref === void 0;
                case 7:
                    if (!_ctx.t0) {
                        _ctx.next = 11;
                        break;
                    }
                    _ctx.t2 = void 0;
                    _ctx.next = 12;
                    break;
                case 11:
                    _ctx.t2 = ref.data;
                case 12:
                    return _ctx.abrupt("return", _ctx.t2);
                case 13:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function fetchStreamsRemainingTime() {
        return _ref.apply(this, arguments);
    };
}();


/***/ }),

/***/ 94895:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$": function() { return /* binding */ uploadMedia; },
/* harmony export */   "D": function() { return /* binding */ MediaType; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(47568);
/* harmony import */ var _home_circleci_project_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _home_circleci_project_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_home_circleci_project_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(87066);



var MediaType;
(function(MediaType) {
    MediaType["Image"] = "image";
    MediaType["Video"] = "video";
    MediaType["Link"] = "link";
    MediaType["Audio"] = "audio";
})(MediaType || (MediaType = {}));
var uploadMedia = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_home_circleci_project_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(file) {
        var formData;
        return _home_circleci_project_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    formData = new FormData();
                    formData.append("file", file);
                    _ctx.next = 4;
                    return axios__WEBPACK_IMPORTED_MODULE_2__/* ["default"].post */ .Z.post("/media/", formData, {
                        headers: {
                            "Content-Type": "multipart/form-data"
                        }
                    });
                case 4:
                    return _ctx.abrupt("return", _ctx.sent.data);
                case 5:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function uploadMedia(file) {
        return _ref.apply(this, arguments);
    };
}();


/***/ }),

/***/ 71397:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"mediaHeader":"MediaContent_mediaHeader__4aPgL","isPostDetail":"MediaContent_isPostDetail__rSWMo","mediaWrapper":"MediaContent_mediaWrapper__utoHG","isVideo":"MediaContent_isVideo__AnOip","imageMedia":"MediaContent_imageMedia__CMtZn","linkMedia":"MediaContent_linkMedia__nn47_","processingLabel":"MediaContent_processingLabel__A16Xt","text":"MediaContent_text__QZ_nb","liveStreamThumbnail":"MediaContent_liveStreamThumbnail__Jj71q","streamInfo":"MediaContent_streamInfo__SkEuo","streamLabel":"MediaContent_streamLabel__REloF","blinker":"MediaContent_blinker__vmFvy","viewerCount":"MediaContent_viewerCount__gMUWA","beforeLiveLabel":"MediaContent_beforeLiveLabel__ar4Ad","timeWrapper":"MediaContent_timeWrapper__fLX45","time":"MediaContent_time__ux917","scaleMaxHeight":"MediaContent_scaleMaxHeight__hSxgU","mediaControlBtn":"MediaContent_mediaControlBtn__BMuKk","lockedOverlayWrapper":"MediaContent_lockedOverlayWrapper__HlQuB","mediaContainer":"MediaContent_mediaContainer__R3RvT","media":"MediaContent_media__VHbS5","linkInfo":"MediaContent_linkInfo__tNMqP","linkTitle":"MediaContent_linkTitle__4TbiA","bottomLeft":"MediaContent_bottomLeft__nqRGe","linkSrc":"MediaContent_linkSrc__OYi0J","timeSince":"MediaContent_timeSince__UkGE1","adsPost":"MediaContent_adsPost__VlbN2","linkMediaNoThumbnail":"MediaContent_linkMediaNoThumbnail__w4wNK","imageWrapper":"MediaContent_imageWrapper__TFEj_","blurred":"MediaContent_blurred__c5mNi","lockImage":"MediaContent_lockImage__qwKea","beforeLiveWrapper":"MediaContent_beforeLiveWrapper__FE7aa","notifyBtn":"MediaContent_notifyBtn__ODFw8"};

/***/ }),

/***/ 1155:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"button":"Button_button__lRS4p","main":"Button_main__VCZxW","subText":"Button_subText__4ejem","rounded":"Button_rounded__kRdAe","disabled":"Button_disabled__kN1RM","alternateColor":"Button_alternateColor__Z0aSL","alternateColorFaded":"Button_alternateColorFaded__hNers","alternateColorWarning":"Button_alternateColorWarning__ujMZe","darkOrange":"Button_darkOrange__TfJxI","pink":"Button_pink__w8qCq","lightRed":"Button_lightRed__OEBoO","hasIcon":"Button_hasIcon__FoGJ8","icon":"Button_icon__TLxHH","blackAndWhite":"Button_blackAndWhite__TDYcU","loading":"Button_loading__Fs4al","faded":"Button_faded__hDylD","fullWidth":"Button_fullWidth__ybG86","fadingStyle":"Button_fadingStyle__6G8n9","bigGuyStyle":"Button_bigGuyStyle__3iaTl","hasSubText":"Button_hasSubText__8kggK"};

/***/ }),

/***/ 77088:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"dialogWrapper":"ImagePreviewDialog_dialogWrapper__iCXb4","closeBtn":"ImagePreviewDialog_closeBtn__1qgdv","image":"ImagePreviewDialog_image__3b4ps"};

/***/ }),

/***/ 83688:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"playerWrapper":"LiveStreamPlayer_playerWrapper__ky3r4","fullscreenVideo":"LiveStreamPlayer_fullscreenVideo__mnQ5p","playerOverlay":"LiveStreamPlayer_playerOverlay__moWIR","streamInfo":"LiveStreamPlayer_streamInfo__nspNg","buffering":"LiveStreamPlayer_buffering__lO8xm","streamLabel":"LiveStreamPlayer_streamLabel__D562p","blinker":"LiveStreamPlayer_blinker__T2EsX","remainingFreeTime":"LiveStreamPlayer_remainingFreeTime__L_LIC","time":"LiveStreamPlayer_time__OIJDF","viewerCount":"LiveStreamPlayer_viewerCount__1migC","mediaControlBtn":"LiveStreamPlayer_mediaControlBtn__dU7tD","pauseBtn":"LiveStreamPlayer_pauseBtn__prbM3","centerBtn":"LiveStreamPlayer_centerBtn__pDW_E","replayWrapper":"LiveStreamPlayer_replayWrapper__IkEb0","replayText":"LiveStreamPlayer_replayText__Ap_2l","playWrapper":"LiveStreamPlayer_playWrapper__QrBTX","bottomBar":"LiveStreamPlayer_bottomBar__PiZc7","timeBarSection":"LiveStreamPlayer_timeBarSection__AOzhK","timebar":"LiveStreamPlayer_timebar__qzjBv","sliderTime":"LiveStreamPlayer_sliderTime__2KCr_","controlButtons":"LiveStreamPlayer_controlButtons__EhvBK","leftCorner":"LiveStreamPlayer_leftCorner__H8p5Y","playTime":"LiveStreamPlayer_playTime__5Mfpc","volumeCtrl":"LiveStreamPlayer_volumeCtrl__XDHcl","volumeSlider":"LiveStreamPlayer_volumeSlider__ktEt6","speakerBtn":"LiveStreamPlayer_speakerBtn__Qp6xV","liveText":"LiveStreamPlayer_liveText__7Totf","rightCorner":"LiveStreamPlayer_rightCorner__p2rwc","fullscreenBtn":"LiveStreamPlayer_fullscreenBtn__YS_Ro","fullscreenText":"LiveStreamPlayer_fullscreenText__tWsnc","notPostDetail":"LiveStreamPlayer_notPostDetail__CMKly","speedCtrl":"LiveStreamPlayer_speedCtrl__TV_Ay","isLiveStreamDetail":"LiveStreamPlayer_isLiveStreamDetail__Ti6t9","isPostDetail":"LiveStreamPlayer_isPostDetail__MglK_","fullscreen":"LiveStreamPlayer_fullscreen__yIuKP"};

/***/ }),

/***/ 93213:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"text":"PlayerRateOptions_text__cZaTl","content":"PlayerRateOptions_content__NkOeL","isWhite":"PlayerRateOptions_isWhite__N3NWW","icon":"PlayerRateOptions_icon__aseI3","isMembership":"PlayerRateOptions_isMembership__aPiqp","isVip":"PlayerRateOptions_isVip__5BvyG"};

/***/ }),

/***/ 88821:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"ring":"ProgressRing_ring__hzLnO","text":"ProgressRing_text__4Acs_","overflow":"ProgressRing_overflow__ADdSW"};

/***/ }),

/***/ 54681:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"richContentWrapper":"RichContent_richContentWrapper__CqUEb","mention":"RichContent_mention__spBez","hashtag":"RichContent_hashtag__ZRc29","email":"RichContent_email__0ipH3","special":"RichContent_special__QvHef","link":"RichContent_link__RRYeT"};

/***/ }),

/***/ 21086:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"textEditorWrapper":"TextEditor_textEditorWrapper__Fvnka","mention":"TextEditor_mention__TxHDC","hashtag":"TextEditor_hashtag__zKuTV","link":"TextEditor_link__dizTP","overLimit":"TextEditor_overLimit__bveki","policy":"TextEditor_policy__5iQoT","description":"TextEditor_description__sEoGK","content":"TextEditor_content__CddCv"};

/***/ }),

/***/ 19951:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"playerWrapper":"VideoPlayer_playerWrapper__Crh9X","isPostDetail":"VideoPlayer_isPostDetail__S_qgy","fullscreenVideo":"VideoPlayer_fullscreenVideo__OPxKz","playerOverlay":"VideoPlayer_playerOverlay__b8HZ_","remainingFreeTime":"VideoPlayer_remainingFreeTime__TRWOJ","time":"VideoPlayer_time__rwwwY","mediaControlBtn":"VideoPlayer_mediaControlBtn__KCla_","pauseBtn":"VideoPlayer_pauseBtn__H79Kp","skipBtn":"VideoPlayer_skipBtn__UgNar","centerBtn":"VideoPlayer_centerBtn__y9Xdp","replayWrapper":"VideoPlayer_replayWrapper__vJEoj","replayText":"VideoPlayer_replayText__Yf5o_","playWrapper":"VideoPlayer_playWrapper__z2X3u","bottomBar":"VideoPlayer_bottomBar__MQ0Gz","timeBarSection":"VideoPlayer_timeBarSection__I39SE","timebar":"VideoPlayer_timebar__aBkt_","sliderTime":"VideoPlayer_sliderTime__laCnN","controlButtons":"VideoPlayer_controlButtons__6_v3u","leftCorner":"VideoPlayer_leftCorner__Q5Gmd","playTime":"VideoPlayer_playTime__jnuhh","volumeCtrl":"VideoPlayer_volumeCtrl__ifKA0","volumeSlider":"VideoPlayer_volumeSlider__UEvbA","speakerBtn":"VideoPlayer_speakerBtn__0SjDl","rightCorner":"VideoPlayer_rightCorner__5XbMw","speedCtrl":"VideoPlayer_speedCtrl__VQuXU","speedCtrlOptions":"VideoPlayer_speedCtrlOptions__hGjLb","speedBtn":"VideoPlayer_speedBtn__50NRq","fullscreenBtn":"VideoPlayer_fullscreenBtn__xLcLw","fullscreenText":"VideoPlayer_fullscreenText__eB724","notPostDetail":"VideoPlayer_notPostDetail__VuFER","fullscreen":"VideoPlayer_fullscreen__az0b1"};

/***/ })

}]);